import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-58e6ee76"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"display":"flex"} }
const _hoisted_2 = { style: {"width":"50%"} }
const _hoisted_3 = { style: {"display":"flex","align-items":"flex-end"} }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "基本信息", -1))
const _hoisted_5 = { style: {"font-size":"22px"} }
const _hoisted_6 = { style: {"margin-left":"15px","display":"flex","gap":"8px"} }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("完善项目信息")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("项目所有附件")
const _hoisted_9 = { class: "cell-item" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("项目类型 ")
const _hoisted_11 = { class: "cell-item" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("事项类型 ")
const _hoisted_13 = { class: "cell-item" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("建模类型 ")
const _hoisted_15 = { class: "cell-item" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("任务类型 ")
const _hoisted_17 = { class: "cell-item" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("计量进度 ")
const _hoisted_19 = { class: "cell-item" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("开始时间 ")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_22 = { class: "cell-item" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("结束时间 ")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_25 = { class: "cell-item" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode("执行人 ")
const _hoisted_27 = { class: "cell-item" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode("审核人 ")
const _hoisted_29 = { class: "cell-item" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode("任务启动人 ")
const _hoisted_31 = {
  key: 0,
  style: {"margin-left":"8px","color":"#909399","font-size":"12px"}
}
const _hoisted_32 = { class: "cell-item" }
const _hoisted_33 = /*#__PURE__*/_createTextVNode("任务标题 ")
const _hoisted_34 = { class: "cell-item" }
const _hoisted_35 = /*#__PURE__*/_createTextVNode("任务状态 ")
const _hoisted_36 = /*#__PURE__*/_createTextVNode("（仅任务启动人可修改状态）")
const _hoisted_37 = { class: "cell-item" }
const _hoisted_38 = /*#__PURE__*/_createTextVNode("执行人计划完成时间 ")
const _hoisted_39 = { class: "cell-item" }
const _hoisted_40 = /*#__PURE__*/_createTextVNode("执行人已读时间 ")
const _hoisted_41 = { class: "cell-item" }
const _hoisted_42 = /*#__PURE__*/_createTextVNode("按时按要求完成 ")
const _hoisted_43 = { class: "flexAlign" }
const _hoisted_44 = /*#__PURE__*/_createTextVNode("可以")
const _hoisted_45 = /*#__PURE__*/_createTextVNode("不能")
const _hoisted_46 = /*#__PURE__*/_createTextVNode("当前：可以")
const _hoisted_47 = /*#__PURE__*/_createTextVNode("当前：不能")
const _hoisted_48 = /*#__PURE__*/_createTextVNode("未判定")
const _hoisted_49 = {
  key: 0,
  style: {"margin-top":"6px","color":"#F56C6C","font-size":"12px","line-height":"1.6"}
}
const _hoisted_50 = { class: "cell-item" }
const _hoisted_51 = /*#__PURE__*/_createTextVNode("是否汇报 ")
const _hoisted_52 = { class: "flexAlign" }
const _hoisted_53 = /*#__PURE__*/_createTextVNode("汇报")
const _hoisted_54 = /*#__PURE__*/_createTextVNode("取消汇报")
const _hoisted_55 = /*#__PURE__*/_createTextVNode("未汇报")
const _hoisted_56 = { class: "cell-item" }
const _hoisted_57 = /*#__PURE__*/_createTextVNode("优先级 ")
const _hoisted_58 = { class: "cell-item" }
const _hoisted_59 = /*#__PURE__*/_createTextVNode("是否添加到第三方平台 ")
const _hoisted_60 = { class: "cell-item" }
const _hoisted_61 = /*#__PURE__*/_createTextVNode("是否加急 ")
const _hoisted_62 = { class: "cell-item" }
const _hoisted_63 = /*#__PURE__*/_createTextVNode("实际完成时间 ")
const _hoisted_64 = { class: "cell-item" }
const _hoisted_65 = /*#__PURE__*/_createTextVNode("评价 ")
const _hoisted_66 = { class: "cell-item" }
const _hoisted_67 = /*#__PURE__*/_createTextVNode("来源人姓名 ")
const _hoisted_68 = { class: "cell-item" }
const _hoisted_69 = /*#__PURE__*/_createTextVNode("来源描述 ")
const _hoisted_70 = { class: "cell-item" }
const _hoisted_71 = /*#__PURE__*/_createTextVNode("备注 ")
const _hoisted_72 = { key: 0 }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1))
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-descriptions__title" }, "建模归档", -1))
const _hoisted_75 = /*#__PURE__*/_createTextVNode("添加建模")
const _hoisted_76 = /*#__PURE__*/_createTextVNode("保存建模")
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1))
const _hoisted_78 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_79 = ["onUpdate:modelValue"]
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1))
const _hoisted_81 = { style: {"width":"150px","float":"left"} }
const _hoisted_82 = { style: {"margin-top":"10px"} }
const _hoisted_83 = /*#__PURE__*/_createTextVNode(" cad照片: ")
const _hoisted_84 = /*#__PURE__*/_createTextVNode("上传文件")
const _hoisted_85 = ["href"]
const _hoisted_86 = ["src"]
const _hoisted_87 = { style: {"width":"150px","float":"left"} }
const _hoisted_88 = { style: {"margin-top":"10px"} }
const _hoisted_89 = /*#__PURE__*/_createTextVNode(" cad文件: ")
const _hoisted_90 = /*#__PURE__*/_createTextVNode("上传文件")
const _hoisted_91 = ["href"]
const _hoisted_92 = { style: {"width":"150px","float":"left"} }
const _hoisted_93 = { style: {"margin-top":"10px"} }
const _hoisted_94 = /*#__PURE__*/_createTextVNode(" 公式文件: ")
const _hoisted_95 = /*#__PURE__*/_createTextVNode("上传文件")
const _hoisted_96 = ["href"]
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1))
const _hoisted_98 = /*#__PURE__*/_createTextVNode("满意度： ")
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"red"} }, "VR建模需在日志中上传作图的依据：对应类别、标准图、对应需建图，调整后的新模图（三张模图附件上传）", -1))
const _hoisted_100 = { key: 1 }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1))
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-descriptions__title" }, "日事日毕", -1))
const _hoisted_103 = { class: "cell-item" }
const _hoisted_104 = /*#__PURE__*/_createTextVNode("反馈日期 ")
const _hoisted_105 = { class: "cell-item" }
const _hoisted_106 = /*#__PURE__*/_createTextVNode("反馈人 ")
const _hoisted_107 = { class: "cell-item" }
const _hoisted_108 = /*#__PURE__*/_createTextVNode("反馈类别 ")
const _hoisted_109 = { class: "cell-item" }
const _hoisted_110 = /*#__PURE__*/_createTextVNode("写单人 ")
const _hoisted_111 = { class: "cell-item" }
const _hoisted_112 = /*#__PURE__*/_createTextVNode("错误类别 ")
const _hoisted_113 = { class: "cell-item" }
const _hoisted_114 = /*#__PURE__*/_createTextVNode("是否与模块公式有关 ")
const _hoisted_115 = { class: "cell-item" }
const _hoisted_116 = /*#__PURE__*/_createTextVNode("负责人签字 ")
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-descriptions__title" }, "改进措施", -1))
const _hoisted_118 = /*#__PURE__*/_createTextVNode("保存改进措施")
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1))
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-descriptions__title" }, "提醒配置", -1))
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1))
const _hoisted_122 = { class: "reminder-config-area" }
const _hoisted_123 = /*#__PURE__*/_createTextVNode("+ 添加提醒")
const _hoisted_124 = {
  key: 0,
  style: {"color":"#909399","font-size":"12px"}
}
const _hoisted_125 = { class: "reminder-row" }
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "reminder-label" }, "提醒类型：", -1))
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "reminder-label",
  style: {"margin-left":"12px"}
}, "提醒人：", -1))
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "reminder-label",
  style: {"margin-left":"12px"}
}, "提醒时间：", -1))
const _hoisted_129 = /*#__PURE__*/_createTextVNode("标记已读")
const _hoisted_130 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_131 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_132 = {
  key: 0,
  class: "reminder-row",
  style: {"margin-top":"6px","align-items":"flex-start"}
}
const _hoisted_133 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "reminder-label",
  style: {"line-height":"32px"}
}, "提醒内容：", -1))
const _hoisted_134 = {
  key: 1,
  class: "reminder-row",
  style: {"margin-top":"6px"}
}
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "reminder-label",
  style: {"color":"#909399","font-size":"12px"}
}, "语音消息推送不支持自定义内容（固定为任务标题）", -1))
const _hoisted_136 = [
  _hoisted_135
]
const _hoisted_137 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1))
const _hoisted_138 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-descriptions__title" }, "任务描述", -1))
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1))
const _hoisted_140 = {
  key: 2,
  class: "tasktype-requirement-area"
}
const _hoisted_141 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"15px"} }, null, -1))
const _hoisted_142 = {
  class: "el-descriptions__title",
  style: {"font-size":"15px","color":"#E6A23C"}
}
const _hoisted_143 = {
  key: 0,
  class: "requirement-block"
}
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "req-label" }, "📋 要求说明：", -1))
const _hoisted_145 = { class: "req-text" }
const _hoisted_146 = {
  key: 1,
  class: "requirement-block"
}
const _hoisted_147 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "req-label" }, "📄 模板文件下载：", -1))
const _hoisted_148 = { class: "req-files" }
const _hoisted_149 = ["href"]
const _hoisted_150 = {
  key: 2,
  class: "requirement-block"
}
const _hoisted_151 = { class: "req-label" }
const _hoisted_152 = /*#__PURE__*/_createTextVNode("📤 要求上传文件（")
const _hoisted_153 = /*#__PURE__*/_createTextVNode("）：")
const _hoisted_154 = { class: "req-upload-header" }
const _hoisted_155 = /*#__PURE__*/_createTextVNode("上传")
const _hoisted_156 = ["href"]
const _hoisted_157 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_158 = ["onChange"]
const _hoisted_159 = /*#__PURE__*/_createTextVNode("保存上传文件")
const _hoisted_160 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1))
const _hoisted_161 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-descriptions__title" }, "当前任务完成百分比", -1))
const _hoisted_162 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1))
const _hoisted_163 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "muted",
  style: {"margin-left":"8px"}
}, "%", -1))
const _hoisted_164 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_165 = { key: 3 }
const _hoisted_166 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1))
const _hoisted_167 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-descriptions__title" }, "投产前备料", -1))
const _hoisted_168 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"10px","color":"#ff0000"} }, "备货信息中包含“碳化实木拼板” 或 “加工” 字样，会要求先加工", -1))
const _hoisted_169 = { style: {"margin-top":"10px","color":"#ff0000"} }
const _hoisted_170 = { style: {"margin-top":"10px","color":"#ff0000"} }
const _hoisted_171 = /*#__PURE__*/_createTextVNode("添加投产前备料")
const _hoisted_172 = /*#__PURE__*/_createTextVNode("保存投产前备料")
const _hoisted_173 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1))
const _hoisted_174 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_175 = ["onUpdate:modelValue"]
const _hoisted_176 = ["onUpdate:modelValue"]
const _hoisted_177 = { style: {"margin-top":"10px"} }
const _hoisted_178 = /*#__PURE__*/_createTextVNode("通过")
const _hoisted_179 = /*#__PURE__*/_createTextVNode("不通过")
const _hoisted_180 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1))
const _hoisted_181 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "el-descriptions__title",
  id: "sec-taskfile"
}, "附件", -1))
const _hoisted_182 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1))
const _hoisted_183 = {
  key: 4,
  class: "flexWrap"
}
const _hoisted_184 = ["href"]
const _hoisted_185 = {
  key: 0,
  style: {"font-size":"11px","color":"#f56c6c","max-width":"120px","word-break":"break-all","text-align":"center"}
}
const _hoisted_186 = /*#__PURE__*/_createTextVNode("作废")
const _hoisted_187 = { key: 5 }
const _hoisted_188 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1))
const _hoisted_189 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-descriptions__title" }, "签字流程", -1))
const _hoisted_190 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1))
const _hoisted_191 = { key: 6 }
const _hoisted_192 = {
  class: "flexAlign",
  style: {"margin-bottom":"10px"}
}
const _hoisted_193 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"100px"} }, "选择表单模板：", -1))
const _hoisted_194 = /*#__PURE__*/_createTextVNode("创建签字流程")
const _hoisted_195 = {
  key: 0,
  style: {"color":"#999","font-size":"12px"}
}
const _hoisted_196 = { key: 7 }
const _hoisted_197 = { class: "form-instance-header" }
const _hoisted_198 = { class: "fi-row" }
const _hoisted_199 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "表单名称：", -1))
const _hoisted_200 = { class: "fi-row" }
const _hoisted_201 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "总负责人：", -1))
const _hoisted_202 = { class: "fi-row" }
const _hoisted_203 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "状态：", -1))
const _hoisted_204 = /*#__PURE__*/_createTextVNode("删除并重新选择")
const _hoisted_205 = ["id"]
const _hoisted_206 = { class: "step-card-title" }
const _hoisted_207 = /*#__PURE__*/_createTextVNode("删除环节")
const _hoisted_208 = {
  key: 0,
  class: "reject-info"
}
const _hoisted_209 = { class: "step-card-content" }
const _hoisted_210 = { class: "fi-row" }
const _hoisted_211 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "执行人：", -1))
const _hoisted_212 = { class: "fi-row" }
const _hoisted_213 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "审核人：", -1))
const _hoisted_214 = {
  key: 0,
  class: "step-data-section"
}
const _hoisted_215 = { class: "fi-row" }
const _hoisted_216 = /*#__PURE__*/_createTextVNode("节点附件 ")
const _hoisted_217 = {
  key: 0,
  class: "tag-warn"
}
const _hoisted_218 = /*#__PURE__*/_createTextVNode("：")
const _hoisted_219 = /*#__PURE__*/_createTextVNode("上传新附件")
const _hoisted_220 = {
  key: 0,
  style: {"margin-top":"5px"}
}
const _hoisted_221 = ["href"]
const _hoisted_222 = /*#__PURE__*/_createTextVNode("已作废")
const _hoisted_223 = {
  key: 1,
  style: {"font-size":"11px","color":"#f56c6c","max-width":"160px","word-break":"break-all"}
}
const _hoisted_224 = /*#__PURE__*/_createTextVNode("作废")
const _hoisted_225 = /*#__PURE__*/_createTextVNode("保存附件")
const _hoisted_226 = {
  key: 1,
  class: "step-data-section"
}
const _hoisted_227 = { class: "fi-row" }
const _hoisted_228 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("节点要求完成时间 "),
  /*#__PURE__*/_createElementVNode("span", { class: "tag-warn" }, "必填"),
  /*#__PURE__*/_createTextVNode("：")
], -1))
const _hoisted_229 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_230 = {
  key: 2,
  class: "step-data-section"
}
const _hoisted_231 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fi-row" }, [
  /*#__PURE__*/_createElementVNode("label", null, [
    /*#__PURE__*/_createTextVNode("节点结论 "),
    /*#__PURE__*/_createElementVNode("span", { class: "tag-warn" }, "必填"),
    /*#__PURE__*/_createTextVNode("：")
  ])
], -1))
const _hoisted_232 = /*#__PURE__*/_createTextVNode("保存结论")
const _hoisted_233 = { class: "fi-row" }
const _hoisted_234 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "执行人签字：", -1))
const _hoisted_235 = {
  key: 0,
  style: {"color":"#909399"}
}
const _hoisted_236 = {
  key: 1,
  style: {"color":"#67C23A"}
}
const _hoisted_237 = /*#__PURE__*/_createTextVNode("执行人签字")
const _hoisted_238 = { class: "fi-row" }
const _hoisted_239 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "审核人签字：", -1))
const _hoisted_240 = {
  key: 0,
  style: {"color":"#909399"}
}
const _hoisted_241 = {
  key: 1,
  style: {"color":"#67C23A"}
}
const _hoisted_242 = /*#__PURE__*/_createTextVNode("审核人签字")
const _hoisted_243 = /*#__PURE__*/_createTextVNode("驳回执行人提交")
const _hoisted_244 = {
  key: 3,
  class: "fi-row"
}
const _hoisted_245 = /*#__PURE__*/_createTextVNode("驳回上一道（退回上一环节）")
const _hoisted_246 = { style: {"margin-bottom":"10px","color":"#909399","font-size":"13px"} }
const _hoisted_247 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_248 = /*#__PURE__*/_createTextVNode("确认驳回")
const _hoisted_249 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1))
const _hoisted_250 = { key: 8 }
const _hoisted_251 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1))
const _hoisted_252 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-descriptions__title" }, "定额任务明细", -1))
const _hoisted_253 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1))
const _hoisted_254 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-descriptions__title" }, "实际完成", -1))
const _hoisted_255 = { class: "rzbor" }
const _hoisted_256 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1))
const _hoisted_257 = /*#__PURE__*/_createTextVNode("保存实际完成")
const _hoisted_258 = /*#__PURE__*/_createTextVNode("查看积压库存")
const _hoisted_259 = /*#__PURE__*/_createTextVNode("接单会签评审记录表")
const _hoisted_260 = { class: "el-descriptions__title" }
const _hoisted_261 = /*#__PURE__*/_createTextVNode("子任务")
const _hoisted_262 = /*#__PURE__*/_createTextVNode("创建子任务")
const _hoisted_263 = ["onClick"]
const _hoisted_264 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1))
const _hoisted_265 = { class: "flexAlign" }
const _hoisted_266 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "el-descriptions__title",
  style: {"margin-right":"10px"}
}, "状态更新", -1))
const _hoisted_267 = /*#__PURE__*/_createTextVNode("可直接在上方\"任务状态\"下拉框中选择修改")
const _hoisted_268 = /*#__PURE__*/_createTextVNode("（仅本任务的启动人可修改任务状态）")
const _hoisted_269 = {
  class: "flexAlign",
  style: {"margin-top":"10px"}
}
const _hoisted_270 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "el-descriptions__title",
  style: {"margin-right":"10px"}
}, "工作台待处理", -1))
const _hoisted_271 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"10px","font-size":"12px","color":"#909399"} }, "控制该任务是否出现在执行人工作台的待处理列表中（审核人待处理列表不受影响）", -1))
const _hoisted_272 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1))
const _hoisted_273 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "el-descriptions__title",
  id: "sec-tasklog"
}, "提交日志", -1))
const _hoisted_274 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1))
const _hoisted_275 = {
  key: 10,
  style: {"color":"#f56c6c","margin-bottom":"10px"}
}
const _hoisted_276 = /*#__PURE__*/_createTextVNode(" 任务未启动，无法提交日志，请先点击\"开启\"启动任务。 ")
const _hoisted_277 = { key: 11 }
const _hoisted_278 = /*#__PURE__*/_createTextVNode("选择计量补交时间：")
const _hoisted_279 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1))
const _hoisted_280 = { class: "rzbor" }
const _hoisted_281 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1))
const _hoisted_282 = /*#__PURE__*/_createTextVNode("上传文件")
const _hoisted_283 = { class: "flexCenter" }
const _hoisted_284 = /*#__PURE__*/_createTextVNode("任务流程")
const _hoisted_285 = /*#__PURE__*/_createTextVNode("提交计量数据")
const _hoisted_286 = /*#__PURE__*/_createTextVNode("提交日志")
const _hoisted_287 = /*#__PURE__*/_createTextVNode("任务完成")
const _hoisted_288 = /*#__PURE__*/_createTextVNode("审核完成")
const _hoisted_289 = /*#__PURE__*/_createTextVNode("审核不通过")
const _hoisted_290 = /*#__PURE__*/_createTextVNode("撤回")
const _hoisted_291 = {
  key: 0,
  style: {"margin-top":"10px"}
}
const _hoisted_292 = /*#__PURE__*/_createTextVNode("此操作同步到同项目下的 事项类型= 订单信息-项目要求、订单信息-新材料、订单信息-新工艺 的任务中（仅对进行中任务有效）")
const _hoisted_293 = { key: 1 }
const _hoisted_294 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"16px","font-weight":"700","text-align":"center","margin":"10px"} }, "任务评价", -1))
const _hoisted_295 = { class: "flexCenter" }
const _hoisted_296 = /*#__PURE__*/_createTextVNode("满意")
const _hoisted_297 = /*#__PURE__*/_createTextVNode("合格")
const _hoisted_298 = /*#__PURE__*/_createTextVNode("不合格")
const _hoisted_299 = { style: {"width":"50%"} }
const _hoisted_300 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-descriptions__title flexCenter" }, "日志展示", -1))
const _hoisted_301 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1))
const _hoisted_302 = {
  key: 0,
  style: {"margin-bottom":"6px"}
}
const _hoisted_303 = /*#__PURE__*/_createTextVNode("已作废")
const _hoisted_304 = { style: {"margin-left":"8px","font-size":"12px","color":"#f56c6c"} }
const _hoisted_305 = { style: {"margin-left":"8px","font-size":"12px","color":"#909399"} }
const _hoisted_306 = { key: 1 }
const _hoisted_307 = ["href"]
const _hoisted_308 = { style: {"font-size":"12px","color":"#606266","max-width":"90px","overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_309 = { style: {"margin-top":"6px"} }
const _hoisted_310 = /*#__PURE__*/_createTextVNode("作废")
const _hoisted_311 = { class: "my-header" }
const _hoisted_312 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "新建任务", -1))
const _hoisted_313 = { class: "my-header" }
const _hoisted_314 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_315 = /*#__PURE__*/_createTextVNode("保 存")
const _hoisted_316 = { class: "my-header" }
const _hoisted_317 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "积压库存", -1))
const _hoisted_318 = { class: "my-header" }
const _hoisted_319 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "接单会签评审记录表", -1))
const _hoisted_320 = { style: {"margin-top":"15px","text-align":"right"} }
const _hoisted_321 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_322 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_323 = { style: {"margin-top":"15px","text-align":"right"} }
const _hoisted_324 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_325 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_326 = { class: "paste_hint" }
const _hoisted_327 = /*#__PURE__*/_createTextVNode(" Ctrl+V 粘贴目标：")
const _hoisted_328 = {
  key: 0,
  style: {"color":"#e6a23c","margin-left":"8px"}
}

import { onMounted,onBeforeUnmount,ref,computed, watch,nextTick } from 'vue';
	import { ElMessage, ElMessageBox } from 'element-plus';
	import {requestModlingmydById,
		requestAddTaskpj,
		requestTaskStatus,
		requestAddTask,
		requestAddTasklog,
		requestTasklogList,
		requestVoidTaskLog,requestVoidTaskFile,requestVoidFileList,requestSetWorkbenchShow,
		requestUpdatePlanEndTime,
		requestUpdateTaskDate,
		requestUpdateFinishPercent,
		requestPriority,
		requestIsAddOtherOs,
		requestIsUrgent,
		xmDetails2,requestTaskInfoById,
		xmUser,requestGetTaskPidList,
		requestreadtask,
		requestTaskqz,
		requestTaskgjcs,
		requestSaveSubTask,requestCheckSubTaskInfo,requestDeleteSubTaskInfo,requestGetSubTaskInfo,
		requestSaveTaskReminder,requestGetTaskReminderList,requestDeleteTaskReminder,requestMarkReminderRead,
		requestGetSelfStartPerm,
		requestUpdateOnTime,
		requestUpdateReport
	} from '@/api/xmApi';
	
	import {
		apiName,requestgettasktableinfo,
		requestMyuser,requestsavesjwc,
		requestZtreeModelingPath,requestSaveModeling,requestGetModelingByTaskid,requestgetselfrole,
		requestsaveremarks
	} from '@/api/api';
	
	import { requestConfigalllisttype3, requestTaskTypeConfigByType, requestGetStartUsers } from '@/api/configApi';
	import { reqFormInstanceTemplateList, reqFormInstanceGetByTask, reqFormInstanceCreate, reqFormInstanceDelete, reqFormInstanceExecutorSign, reqFormInstanceReviewerSign, reqFormInstanceSaveStepData, reqFormInstanceDeleteStep, reqFormInstanceReject, reqFormInstanceRejectCurrent } from '@/api/forminstanceApi';
	import { requestSaveRequiredFiles } from '@/api/xmApi';
	import AddTask from '@/components/AddTask.vue';
import ProjectInfoEdit from '@/components/ProjectInfoEdit.vue';
import ProjectAllFiles from '@/components/ProjectAllFiles.vue';
	import OverstockList from '@/components/overstocklist.vue';
	import sqpspage from '@/views/bd/sqps.vue';
	
export default /*#__PURE__*/_defineComponent({
  name: 'TaskDetails',
  props: {
		form:{
			'type': Object,
			default: () => {}
		},
		// 需要定位（滚动+高亮）到的签字环节 id，由外部（如表单甘特图点击环节）传入
		focusStepId:{
			type: [String, Number],
			default: ''
		},
		// 由"项目所有附件"跳转进来时的定位目标：tasklog=任务日志，taskfile=任务附件，sign=签字流程
		focusTarget:{
			type: String,
			default: ''
		},
		// 需要定位到的任务日志 id
		focusLogId:{
			type: [String, Number],
			default: ''
		}
	},
  emits: ['taskListsx'],
  setup(__props, { emit }) {

const props = __props

	const addShowTask = ref<boolean>(false)//添加任务
	const showoverstock = ref<boolean>(false)//积压库存
	const showsqps= ref<boolean>(false)//评审
	// 提醒配置
	const reminderList = ref<any[]>([])
	// 事项类型配置
	const taskTypeConfig = ref<any>({ templatefiles: '[]', requirements: '', requireduploads: '' })
	const requiredUploadNames = ref<string[]>([])  // 要求上传文件名数组
	const requiredUploadsMap = ref<Record<string, string>>({})  // {文件名: 已上传URL}
	
	const liuceng1=ref('')
	const liuceng2=ref('')
	const jlbjrq=ref('')
	const userrole = ref<string>("")//用户角色
	const type4DataList = ref<any[]>([]);
	const addTask = ref<boolean>(false)
	// 任务启动人相关
	const startUsers = ref<any[]>([])       // 有"启动任务"权限的用户列表
	const canStartTask = ref<boolean>(false) // 当前用户是否有启动任务权限
	const taskStartUserid = ref<number>(0)   // 当前任务的启动人用户id
	const taskStartUsername = ref<string>('') // 当前任务的启动人名称
	const isTaskStarter = ref<boolean>(false) // 当前用户是否为本任务的启动人（可修改状态）
	const statusSelect = ref<number>(0)       // 任务状态下拉当前选中值
	const updateremark = ref('')
	const changeReasonDialog = ref(false)
	const currentFieldToChange = ref('')
	// 按时按要求完成：反馈原因弹窗
	const ontimeReasonDialog = ref(false)
	const ontimeReason = ref('')
	const userList = ref<any>({})
	const sonTaskList = ref<any>({})
	
	
	const apiname = ref<string>(apiName)
	const form = ref<any>({})
	const userLists = ref<any[]>([])
	const priorityLists = ref<any[]>([])
	priorityLists.value=["紧急","高","中","低"]
	// 当前任务完成百分比（所有人可输入）
	const finishPercent = ref<number>(0)
	// 支持"同步操作"的订单信息类事项类型
	const orderInfoTypes = ['订单信息-项目要求', '订单信息-新材料', '订单信息-新工艺']
	// 当前任务是否为订单信息类事项（决定是否显示同步复选框）
	const isOrderInfoType = computed(() => orderInfoTypes.indexOf(form.value.type1) > -1)
	// 是否把本次操作同步到同项目下同类事项的进行中任务
	const syncToOrder = ref<boolean>(false)
	const syncFinishPercent = () => {
		const p = Number(form.value.finishpercent)
		finishPercent.value = isNaN(p) ? 0 : Math.max(0, Math.min(100, p))
	}
	const pjLists = ref<any[]>([])
	pjLists.value=["满意","合格","不合格"]
	const otherosLists = ref<any[]>([])
	otherosLists.value=["是","否"]
	const zxr = ref('')
	const shr = ref('')
	const priority2 = ref('')
	const isaddotheros = ref('')
	const isurgent = ref('')
	const urgentLists = ref<any[]>([])
	urgentLists.value=["是","否"]
	const addFileList = ref<any[]>([])
	const fileList = ref<any[]>([])
	const logList = ref<any[]>([])
	// 已作废的附件（任务附件 + 签字流程节点附件）
	const voidFileList = ref<any[]>([])
	// 是否显示在执行人工作台的待处理列表（默认显示）
	const showInWorkbench = ref<boolean>(true)
	const workbenchToggling = ref<boolean>(false)
	// 依据任务数据同步开关状态（未设置时按"显示"处理）
	const syncShowInWorkbench = () => {
		const v = form.value.showinworkbench
		showInWorkbench.value = (v === undefined || v === null || v === '' || Number(v) === 1)
	}
	// 开启/关闭：仅影响执行人工作台待处理列表，审核人列表不受影响
	const toggleWorkbenchShow = (val: boolean) => {
		const show = val ? 1 : 0
		workbenchToggling.value = true
		requestSetWorkbenchShow({
			taskuuid: form.value.uuid,
			taskid: form.value.id,
			show: show
		}).then((res:any)=>{
			if(res.status === 1){
				form.value.showinworkbench = show
				showInWorkbench.value = val
				ElMessage({ message: res.msg, type: 'success', duration: 800 })
			} else {
				// 失败则回滚开关状态
				showInWorkbench.value = !val
				ElMessage.error(res.msg || '设置失败')
			}
		}).catch(()=>{
			showInWorkbench.value = !val
			ElMessage.error('设置失败')
		}).finally(()=>{
			workbenchToggling.value = false
		})
	}
	const tasktable = ref<any[]>([])
	const modelingList = ref<any[]>([])
	const subTaskList = ref<any[]>([])
	let addfjArr:any[] = []

	// 解析 filelist 中 "url|name" 片段，返回 {url, name}
	const parseFileItem = (s: string) => {
		if (!s) return { url: '', name: '' }
		const idx = s.indexOf('|')
		if (idx >= 0) {
			return { url: s.substring(0, idx), name: s.substring(idx + 1) }
		}
		// 旧数据无文件名：取 url 末段作为名
		const seg = s.split('/')
		return { url: s, name: seg[seg.length - 1] || '附件' }
	}
	// 生成下载/打开链接（走后端下载代理，inline 直接打开 + 原始文件名）
	const fileOpenUrl = (s: string) => {
		const it = parseFileItem(s)
		if (!it.url) return ''
		const seg = it.url.split('/')
		const fname = it.name || (seg[seg.length - 1] || '附件')
		return `${apiname.value}/frame/downloadfile?p=${encodeURIComponent(seg.slice(1).join('/'))}&n=${encodeURIComponent(fname)}`
	}
	
	const modelingpathLists = ref<any[]>([])
	// 签字流程相关
	const formTemplateList = ref<any[]>([])
	const selectedTemplateId = ref<number>(0)
	const formInstance = ref<any>(null)
	const formInstanceSteps = ref<any[]>([])
	const formInstanceRejects = ref<any[]>([]) // 驳回记录（驳回人/时间/原因）
	const stepAttachUploadList = ref<any[]>([])
	const projectobj = ref<any>({
		'code':"",
	})
	const getStatus = computed(()=>{
		return function(status:number){
			if(status=="0") return "未启动";
			if(status=="1") return "进行中";
			if(status=="2") return "关闭";
			if(status=="3") return "待审核";
			if(status=="4") return "完成";
			return status;
	}})
	const getpj = computed(()=>{
		return function(status:number){
			if(status==1) return "满意";
			if(status==2) return "合格";
			if(status==3) return "不合格";
			if(status==0) return "未打分";
			return "";
	}})
	// 解析模板文件数组
	const parsedTemplateFiles = computed(() => {
		try {
			const tf = taskTypeConfig.value.templatefiles;
			if (!tf || tf === '[]') return [];
			return JSON.parse(tf);
		} catch { return []; }
	})
	// 事项类型配置 - 上传相关引用
	const requiredFileInputs = ref<Record<string, HTMLInputElement | null>>({})
	const setUploadRef = (name: string, el: any) => { requiredFileInputs.value[name] = el; }
	// 加载事项类型配置
	const loadTaskTypeConfig = () => {
		const typename = form.value.type1;
		if (!typename) { taskTypeConfig.value = { templatefiles: '[]', requirements: '', requireduploads: '' }; requiredUploadNames.value = []; requiredUploadsMap.value = {}; return; }
		requestTaskTypeConfigByType({ typename: typename }).then((res: any) => {
			if (res.status === 1) {
				taskTypeConfig.value = res.datalist || { templatefiles: '[]', requirements: '', requireduploads: '' };
				// 解析要求上传文件名
				const ru = taskTypeConfig.value.requireduploads || '';
				requiredUploadNames.value = ru ? ru.split(',').map((s: string) => s.trim()).filter(Boolean) : [];
				// 解析已上传文件
				try {
					requiredUploadsMap.value = form.value.requiredfiles ? JSON.parse(form.value.requiredfiles) : {};
				} catch { requiredUploadsMap.value = {}; }
			} else {
				taskTypeConfig.value = { templatefiles: '[]', requirements: '', requireduploads: '' };
				requiredUploadNames.value = [];
				requiredUploadsMap.value = {};
			}
		});
	};
	const triggerRequiredUpload = (name: string) => { requiredFileInputs.value[name]?.click(); }
	const handleRequiredFileChange = (e: any, name: string) => {
		const file = e.target.files?.[0];
		if (!file) return;
		const formData = new FormData();
		formData.append('file', file);
		fetch(`${apiname.value}/frame/uploadfile1`, { method: 'POST', body: formData })
			.then(r => r.json())
			.then((res: any) => {
				if (res.errno === 0 && res.data && res.data[0]) {
					requiredUploadsMap.value[name] = res.data[0].url;
					ElMessage({ message: `${name} 上传成功`, type: 'success', duration: 1000 });
				} else { ElMessage.error(`${name} 上传失败`); }
			})
			.catch(() => ElMessage.error(`${name} 上传异常`));
		// 重置input以便同名文件可重复选择
		e.target.value = '';
	};
	const removeRequiredFile = (name: string) => { delete requiredUploadsMap.value[name]; };
	const getUploadedCount = () => Object.keys(requiredUploadsMap.value).length;
	const checkAllRequiredUploaded = () => requiredUploadNames.value.length > 0 && requiredUploadNames.value.every(n => requiredUploadsMap.value[n]);
	const checkRequiredFilesForSubmit = () => requiredUploadNames.value.length === 0 || checkAllRequiredUploaded();
	const saveRequiredFilesToServer = () => {
		requestSaveRequiredFiles({ uuid: form.value.uuid, requiredfiles: JSON.stringify(requiredUploadsMap.value) }).then((res: any) => {
			if (res.status === 1) { ElMessage({ message: '上传文件保存成功', type: 'success', duration: 1000 }); }
			else { ElMessage.error(res.msg || '保存失败'); }
		});
	};
	//新建任务
	const createTask = () => {
		tasksx()
		addShowTask.value = true
	}
	const tasksx = () => {
		addTask.value = false
		nextTick(()=>{
			addTask.value = true
		})
	}
	const savesjwc = () => {
		/*const dataToSave = type4DataList.value.map(item => ({
			confid: item.confid,
			name: item.name,
			qty: item.qty,
			completedQty: item.completedQty
		}));*/
		const dataToSave = type4DataList.value.filter(item => item.qty != 0 || item.completedQty != 0)
            .map(item => ({
                confid: item.confid,
                name: item.name,
                qty: item.qty,
                completedQty: item.completedQty,
                serialNumbers: item.serialNumbers || []
            }));

    	const jsonStr = JSON.stringify(dataToSave);
		console.log(jsonStr)
		requestsavesjwc({
			uuid:form.value.uuid,
			sjwc:form.value.sjwc,
			jsonStr:jsonStr
		}).then((res:any)=>{
			if(res.status === 1){
				ElMessage({
					message: "保存成功",
					type: 'success',
					duration: 500
				});
				setTimeout(()=>{
					getLogList();
				},500)
			}
		})
	}
	const changeZxr = () => {
		requestAddTask({
			type:'zxr',
			uuid:form.value.uuid,
			operatoruserid:zxr.value.split(',')[0],
			operatorname:zxr.value.split(',')[1],
			taskid:form.value.id,
			stepid:form.value.stepid,
			status:4
		}).then((res:any)=>{
			if(res.status === 1){
				ElMessage({
					message: "修改成功",
					type: 'success',
					duration: 500
				});
				setTimeout(()=>{
					getLogList();
				},500)
			}
		})
	}
	const changeoperatorplanendtime = ()=>{
		//alert(form.value.operatorplanendtime);
		requestUpdatePlanEndTime({
			taskuuid:form.value.uuid,
			updateremark:"执行人计划完成时间:"+form.value.operatorplanendtime,
			filelist:"",
			status:form.value.status,
			operatorplanendtime:form.value.operatorplanendtime,
		}).then((res:any)=>{
			if(res.status === 1){
				ElMessage({
					message: "修改成功",
					type: 'success',
					duration: 500
				});
				setTimeout(()=>{
					getLogList();
				},500)
			}
		})
	}
	const changeShr = () => {
		requestAddTask({
			type:'shr',
			uuid:form.value.uuid,
			checkuserid:shr.value.split(',')[0],
			checkname:shr.value.split(',')[1],
			status:4
		}).then((res:any)=>{
			if(res.status === 1){
				ElMessage({
					message: "修改成功",
					type: 'success',
					duration: 500
				});
				setTimeout(()=>{
					getLogList();
				},500)
			}
		})
	}
	const changepriority  = () => {
		requestPriority({
			uuid:form.value.uuid,
			priority2:priority2.value
		}).then((res:any)=>{
			if(res.status === 1){
				ElMessage({
					message: "修改成功",
					type: 'success',
					duration: 500
				});
				setTimeout(()=>{
					getLogList();
				},500)
			}
		})
	}
	// 将当前任务的启动人同步到下拉框
	const syncStartUser = () => {
		const uid = Number(form.value.taskstartuserid)
		taskStartUserid.value = isNaN(uid) ? 0 : uid
		taskStartUsername.value = form.value.taskstartusername || ''
		// 当前用户是否为本任务的启动人（决定能否修改任务状态）
		const myId = Number(userList.value && userList.value.id)
		isTaskStarter.value = !isNaN(uid) && uid > 0 && myId > 0 && uid === myId
		// 同步状态下拉当前值
		statusSelect.value = Number(form.value.status) || 0
	}
	// 修改任务启动人（需有启动任务权限，由后端二次校验）
	const changeStartUser = () => {
		if (!taskStartUserid.value) {
			ElMessage.error('请选择任务启动人')
			return
		}
		// 始终根据所选 id 重新匹配名称，避免沿用旧名称导致日志/存储错乱
		const matched = startUsers.value.find((u) => Number(u.id) === Number(taskStartUserid.value))
		const newName = matched ? matched.name : String(taskStartUserid.value)
		taskStartUsername.value = newName
		requestAddTask({
			type: 'startuser',
			uuid: form.value.uuid,
			taskstartuserid: taskStartUserid.value,
			taskstartusername: newName,
			status: form.value.status
		}).then((res: any) => {
			if (res.status === 1) {
				ElMessage({ message: '修改启动人成功', type: 'success', duration: 500 })
				form.value.taskstartuserid = taskStartUserid.value
				form.value.taskstartusername = newName
				setTimeout(() => { getLogList() }, 500)
			} else {
				ElMessage.error(res.msg || '修改失败')
				// 失败则回滚选值
				syncStartUser()
			}
		})
	}
	const changemyd  = (item:any) => {
		console.log(item.id,item.pj)
		requestModlingmydById({
			id:item.id,
			myd:item.pj,
		}).then((res:any)=>{
			if(res.status === 1){
				ElMessage({
					message: "修改成功",
					type: 'success',
					duration: 500
				});
			}
		})
	}
	const changeadd  = () => {
		requestIsAddOtherOs({
			uuid:form.value.uuid,
			isaddotheros:isaddotheros.value
		}).then((res:any)=>{
			if(res.status === 1){
				ElMessage({
					message: "修改成功",
					type: 'success',
					duration: 500
				});
				setTimeout(()=>{
					getLogList();
				},500)
			}
		})
	}
	const changeurgent  = () => {
		requestIsUrgent({
			uuid:form.value.uuid,
			isurgent:isurgent.value
		}).then((res:any)=>{
			if(res.status === 1){
				ElMessage({
					message: "修改成功",
					type: 'success',
					duration: 500
				});
				setTimeout(()=>{
					getLogList();
				},500)
			}
		})
	}
	// ========== 按时按要求完成（可以/不能）==========
	// flag: 1=可以 2=不能；选择"不能"时先弹窗填写反馈原因
	const setOnTime = (flag: number) => {
		// 任务未启动时禁止操作（与提交日志保持一致）
		if (Number(form.value.status) === 0) {
			ElMessage.error("任务未启动，无法操作");
			return;
		}
		if (flag === 1) {
			doUpdateOnTime(1, '');
		} else {
			// 回填已有原因，便于修改后重新提交
			ontimeReason.value = form.value.ontimereason || '';
			ontimeReasonDialog.value = true;
		}
	}
	// 确认提交"不能"的反馈原因
	const confirmOnTimeReason = () => {
		if (!ontimeReason.value.trim()) {
			ElMessage.error("请填写反馈原因");
			return;
		}
		doUpdateOnTime(2, ontimeReason.value.trim());
	}
	// 调用后端更新判定并记录日志
	const doUpdateOnTime = (flag: number, reason: string) => {
		requestUpdateOnTime({
			uuid: form.value.uuid,
			ontimeflag: flag,
			ontimereason: reason
		}).then((res:any)=>{
			if(res.status === 1){
				ElMessage({
					message: "操作成功",
					type: 'success',
					duration: 500
				});
				ontimeReasonDialog.value = false;
				// 立即回显，不依赖接口刷新
				form.value.ontimeflag = String(flag);
				form.value.ontimereason = reason;
				setTimeout(()=>{
					getLogList();
				},500)
			} else {
				ElMessage.error(res.msg || "操作失败");
			}
			})
			}
			// ========== 任务是否汇报（汇报/取消汇报）==========
			// flag: 1=汇报 0=取消汇报
			const setReport = (flag: number) => {
			// 任务未启动时禁止操作（与提交日志保持一致）
			if (Number(form.value.status) === 0) {
			ElMessage.error("任务未启动，无法操作");
			return;
			}
			const doing = flag === 1
			// 取消汇报需二次确认，避免误操作
			if (!doing) {
			ElMessageBox.confirm('确定要取消该任务的汇报状态吗？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				doUpdateReport(0)
			}).catch(() => {})
			return
			}
			doUpdateReport(1)
			}
			// 调用后端更新汇报状态并记录日志
			const doUpdateReport = (flag: number) => {
			requestUpdateReport({
			uuid: form.value.uuid,
			reportflag: flag
			}).then((res:any)=>{
			if(res.status === 1){
				ElMessage({
					message: flag === 1 ? "汇报成功" : "已取消汇报",
					type: 'success',
					duration: 500
				});
				// 立即回显：汇报时写入当前时间，取消时清空
				form.value.reportflag = flag === 1 ? '1' : '';
				form.value.reporttime = flag === 1 ? formatNow() : '';
				setTimeout(()=>{
					getLogList();
				},500)
			} else {
				ElMessage.error(res.msg || "操作失败");
			}
			})
			}
			// 生成本地当前时间字符串（与后端 GetDateTime 格式一致：YYYY-MM-DD HH:mm:ss）
			const formatNow = () => {
			const d = new Date()
			const p = (n: number) => (n < 10 ? '0' + n : String(n))
			return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`
			}

	const getTaskStatus = (status:Number) => {
		requestTaskStatus({
			status:status,
			uuid:form.value.uuid
		}).then((res:any)=>{
			if(res.status === 1){
				ElMessage({
					message: res.msg,
					type: 'success',
					duration: 500
				});
				form.value.status = status
				statusSelect.value = Number(status) || 0
				// setTimeout(()=>{
				// 	emit("taskListsx")
				// },500)
			}
		})
	}
	const cancelTask = (val:any) =>{
		addShowTask.value = false
		if(val){
			getGonTaskList();
		}
	}
	// 保存开始时间
	const saveStartTime = () => {
		if(!form.value.startdate) {
			ElMessage.error('请选择开始时间');
			return;
		}
		currentFieldToChange.value = 'startdate';
		changeReasonDialog.value = true;
	}
	// 保存结束时间
	const saveEndTime = () => {
		if(!form.value.enddate) {
			ElMessage.error('请选择结束时间');
			return;
		}
		currentFieldToChange.value = 'enddate';
		changeReasonDialog.value = true;
	}
	// 确认修改时间
	const confirmChangeTime = () => {
		if(!updateremark.value.trim()) {
			ElMessage.error('请输入修改原因');
			return;
		}
		
		// 调用后端API实际修改时间
		requestUpdateTaskDate({
			taskuuid: form.value.uuid,
			field: currentFieldToChange.value,
			datevalue: form.value[currentFieldToChange.value],
			updateremark: `修改${currentFieldToChange.value === 'startdate' ? '开始时间' : '结束时间'}为${form.value[currentFieldToChange.value]}，原因：${updateremark.value}`,
		}).then((res:any)=>{
			if(res.status === 1){
				ElMessage({
					message: res.msg,
					type: 'success',
					duration: 500
				});
				changeReasonDialog.value = false;
				updateremark.value = '';
				toTask(form.value.id);
				getLogList();
			} else {
				ElMessage.error(res.msg || '修改失败');
			}
		});
	}
	onMounted(()=>{
		requestgetselfrole().then((res:any)=>{
			if(res.status === 1){
				userrole.value = res.datalist
				console.log(userrole.value)
			}
		})
		requestZtreeModelingPath().then((res:any)=>{
			modelingpathLists.value = res.datalist
		})
		getUserList()
		getMyUser();
		// 附件支持 Ctrl + V 粘贴上传
		document.addEventListener('paste', onPaste)
		form.value = props.form;
		syncFinishPercent();
		syncStartUser();
		syncShowInWorkbench();
		// 加载启动权限相关
		requestGetSelfStartPerm({}).then((res: any) => {
			canStartTask.value = res.status === 1 && res.datalist === '1'
		})
		requestGetStartUsers({}).then((res: any) => {
			if (res.status === 1) {
				startUsers.value = res.datalist || []
			}
		})
		console.log(form.value.id)
		toTask(form.value.id);
		setTimeout(()=>{
					
		
		console.log(form.value)
		getModelingByTaskid()
		getSubTaskInfoByTaskid()
		requestreadtask({
			taskid:form.value.id
		}).then((res:any)=>{
		})
		xmDetails2({
			id:form.value.projectid
		}).then((res:any)=>{
			projectobj.value=res.datalist[0];
		})
		//if(form.value.filelist != ""){
		//	fileList.value = form.value.filelist.split(",")
		//}
		getLogList();
		zxr.value = `${form.value.operatoruserid},${form.value.operatorname}`
		shr.value = `${form.value.checkuserid},${form.value.checkname}`
		priority2.value=`${form.value.priority2}`
		isaddotheros.value=`${form.value.isaddotheros}`
		isurgent.value=`${form.value.isurgent}`
		getGonTaskList();
		
		if(form.value.type1=="售前-评审"){
			showoverstock.value=true
		}
		console.log(form.value);

		// 加载签字流程数据
		loadFormTemplateList();
		loadFormInstanceData();

		requestConfigalllisttype3({
			t1:'任务流程-售前-常规材料'
		}).then((res:any)=>{
			if(res.status === 1){
				liuceng1.value=res.datalist[0].field0;
				liuceng2.value=res.datalist[1].field0;
			}
		})
		},500)
		 
	})
	const parseType4Data = () => {
		console.log(form.value.type4jsonstr)
    if (form.value.type4jsonstr) {
        try {
            // 解析 JSON 字符串
            const parsed = JSON.parse(form.value.type4jsonstr);
            // 确保是数组，并为每个项添加响应式的 completedQty (完成量)，默认为 0 或已有值
            type4DataList.value = parsed.map((item: any) => ({
                ...item,
                // 如果原数据中没有 completedQty，则初始化为 0，否则保留原值
                completedQty: item.completedQty !== undefined ? item.completedQty : 0
            }));
        } catch (e) {
            console.error("解析 type4jsonstr 失败", e);
            type4DataList.value = [];
        }
    } else {
        type4DataList.value = [];
    }
};

// 定额任务相关方法
const getSerialNumberInputs = (row: any) => {
	const inputs = [];
	for(let i = 0; i < row.completedQty; i++) {
		if(!row.serialNumbers) {
			row.serialNumbers = [];
		}
		if(!row.serialNumbers[i]) {
			row.serialNumbers[i] = { serialNumber: '', problemDesc: '' };
		}
		inputs.push(row.serialNumbers[i]);
	}
	return inputs;
};

const getProblemDescInputs = (row: any) => {
	const inputs = [];
	for(let i = 0; i < row.completedQty; i++) {
		if(!row.serialNumbers) {
			row.serialNumbers = [];
		}
		if(!row.serialNumbers[i]) {
			row.serialNumbers[i] = { serialNumber: '', problemDesc: '' };
		}
		inputs.push(row.serialNumbers[i]);
	}
	return inputs;
};

const onCompletedQtyChange = (row: any) => {
	if(row.completedQty > 0) {
		if(!row.serialNumbers) {
			row.serialNumbers = [];
		}
		// 确保数组长度与完成量一致
		while(row.serialNumbers.length < row.completedQty) {
			row.serialNumbers.push({ serialNumber: '', problemDesc: '' });
		}
		// 如果完成量减少，截断数组
		if(row.serialNumbers.length > row.completedQty) {
			row.serialNumbers = row.serialNumbers.slice(0, row.completedQty);
		}
	} else {
		row.serialNumbers = [];
	}
};


	const func_gettasktableinfo = () => {
		requestgettasktableinfo({
			taskid:form.value.id,
			type1:form.value.type1,
		}).then((res:any)=>{
			if(res.status === 1){
				tasktable.value = res.datalist
			}
		})
	}
	const getGonTaskList = () => {
		requestGetTaskPidList({
			taskpid:form.value.id
		}).then((res:any)=>{
			if(res.status === 1){
				sonTaskList.value = res.datalist
			}
		})
	}
	const toTask = (taskid: string) => {
		console.log(taskid);
		requestTaskInfoById({
				taskid:taskid
			}).then((res:any)=>{
				form.value =res.datalist
				syncFinishPercent();
				syncShowInWorkbench();
				syncStartUser();
				xmDetails2({
					id:form.value.projectid
				}).then((res:any)=>{
					projectobj.value=res.datalist[0];
				})
							if(form.value.filelist != ""){
					fileList.value = form.value.filelist.split(",")
					}
					getLogList();
					// 加载已作废附件（任务附件标记用）
					loadVoidFiles();
				zxr.value = `${form.value.operatoruserid},${form.value.operatorname}`
				shr.value = `${form.value.checkuserid},${form.value.checkname}`
				priority2.value=`${form.value.priority2}`
				isaddotheros.value=`${form.value.isaddotheros}`
		isurgent.value=`${form.value.isurgent}`
				getGonTaskList();
				parseType4Data();
				func_gettasktableinfo();
				// 重新加载签字流程数据
				loadFormInstanceData();
				// 加载提醒配置
				loadReminderList();
				// 加载事项类型配置
				loadTaskTypeConfig();
			})
	}
	const getLogList = () => {
		requestTasklogList({
			taskuuid:form.value.uuid
		}).then((res:any)=>{
			if(res.status === 1){
				logList.value = res.datalist
				// 日志就绪后按需滚动定位（来自"项目所有附件"的跳转）
				scrollToFocusTarget()
			}
		})
	}
	// ===== 作废功能 =====
	// 加载本任务已作废的附件
	const loadVoidFiles = () => {
		if(!form.value.uuid) return
		requestVoidFileList({ taskuuid: form.value.uuid }).then((res:any)=>{
			if(res.status === 1){
				voidFileList.value = res.datalist || []
			}
		})
	}
	// 根据附件地址取作废信息（未作废返回 null）
	const getVoidFile = (url:string): any => {
		if(!url) return null
		const hit = voidFileList.value.find((v:any)=> String(v.fileurl) === String(url))
		return hit || null
	}
	// 附件地址：兼容 "url|name" 写法
	const fileUrlOf = (s:string): string => {
		return parseFileItem(s).url || String(s || '')
	}
	// 统一的原因输入弹窗
	const askVoidReason = (title:string): Promise<string> => {
		return new Promise((resolve, reject) => {
			ElMessageBox.prompt('请输入作废原因', title, {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				inputType: 'textarea',
				inputPlaceholder: '作废原因（必填）',
				inputValidator: (v:string) => (v && v.trim() ? true : '作废原因不能为空')
			}).then(({ value }:any)=>{
				resolve(String(value || '').trim())
			}).catch(()=>{
				reject(new Error('cancel'))
			})
		})
	}
	// 1、作废任务日志
	const voidLog = (item:any) => {
		if(Number(item.voidflag) === 1){
			ElMessage.warning('该日志已作废')
			return
		}
		askVoidReason('作废日志').then((reason:string)=>{
			requestVoidTaskLog({
				id: item.id,
				taskuuid: form.value.uuid,
				taskid: form.value.id,
				reason: reason,
				status: form.value.status
			}).then((res:any)=>{
				if(res.status === 1){
					ElMessage({ message: '已作废', type: 'success', duration: 500 })
					getLogList()
				} else {
					ElMessage.error(res.msg || '作废失败')
				}
			})
		}).catch(()=>{})
	}
	// 2、作废任务附件
	const voidTaskFile = (f:string) => {
		const url = fileUrlOf(f)
		if(getVoidFile(url)){
			ElMessage.warning('该附件已作废')
			return
		}
		askVoidReason('作废任务附件').then((reason:string)=>{
			requestVoidTaskFile({
				taskuuid: form.value.uuid,
				scopetype: 'task',
				refid: form.value.uuid,
				fileurl: url,
				reason: reason,
				status: form.value.status
			}).then((res:any)=>{
				if(res.status === 1){
					ElMessage({ message: '已作废', type: 'success', duration: 500 })
					loadVoidFiles()
					getLogList()
				} else {
					ElMessage.error(res.msg || '作废失败')
				}
			})
		}).catch(()=>{})
	}
	// 3、作废签字流程节点附件
	const voidStepFile = (step:any, f:string) => {
		const url = fileUrlOf(f)
		if(getVoidFile(url)){
			ElMessage.warning('该附件已作废')
			return
		}
		askVoidReason('作废节点附件').then((reason:string)=>{
			requestVoidTaskFile({
				taskuuid: form.value.uuid,
				scopetype: 'step',
				refid: String(step.id),
				fileurl: url,
				reason: reason,
				status: form.value.status
			}).then((res:any)=>{
				if(res.status === 1){
					ElMessage({ message: '已作废', type: 'success', duration: 500 })
					loadVoidFiles()
					getLogList()
				} else {
					ElMessage.error(res.msg || '作废失败')
				}
			})
		}).catch(()=>{})
	}
	const getMyUser = () => {
		requestMyuser().then((res:any)=>{
			if(res.status === 1){
				userList.value = res.datalist[0]
				console.log("userid",userList.value.id);
				console.log("shrid",form.value.checkuserid);
				console.log(userList.value.name);
				console.log(getUserIdName())
				// 当前用户信息加载完成后再重新计算 isTaskStarter（任务启动人权限）
				syncStartUser()
			}
		})
	}
	//提交任务日志
	const submitpj = (pj: number) => {
		requestAddTaskpj({
			id:form.value.id,
			taskuuid:form.value.uuid,
			pj:pj,
		}).then((res:any)=>{
			if(res.status === 1){
				ElMessage({
					message: res.msg,
					type: 'success',
					duration: 500
				});
				// getTaskStatus(status);
				setTimeout(()=>{
					form.value.status = status
					updateremark.value = ""
					addfjArr = []
					addFileList.value = []
					getLogList();
				},500)
			}
		})
	}
	const qz = (id: number) => {
		requestTaskqz({
			id:id
		}).then((res:any)=>{
			if(res.status === 1){
				ElMessage({
					message: res.msg,
					type: 'success',
					duration: 500
				});
				toTask(String(id));
			}
		})
	}
	const savegjcs = (id: number) => {
		requestTaskgjcs({
			id:id,
			tasktitle:form.value.tasktitle,
			gjcs:form.value.gjcs
		}).then((res:any)=>{
			if(res.status === 1){
				ElMessage({
					message: res.msg,
					type: 'success',
					duration: 500
				});
				toTask(String(id));
			}
		})
	}
	const saveRemarks = () => {
		requestsaveremarks({
			uuid: form.value.uuid,
			taskid: form.value.id,
			remarks: form.value.remarks
		}).then((res:any)=>{
			if(res.status === 1){
				ElMessage({
					message: '备注保存成功',
					type: 'success',
					duration: 500
				});
				getLogList();
			}
		})
	}
	const saveFinishPercent = () => {
		requestUpdateFinishPercent({
			uuid: form.value.uuid,
			taskid: form.value.id,
			percent: finishPercent.value
		}).then((res:any)=>{
			if(res.status === 1){
				form.value.finishpercent = finishPercent.value
				ElMessage({
					message: '完成百分比保存成功',
					type: 'success',
					duration: 500
				});
				getLogList();
			} else {
				ElMessage({
					message: res.msg || '保存失败',
					type: 'error'
				});
			}
		})
	}	
	const submit = (status: number,name: string) => {
		// 任务未启动时禁止提交日志
		if (Number(form.value.status) === 0) {
			ElMessage.error("任务未启动，无法提交日志");
			return;
		}
		if (form.value.type1=='日事日毕'){
			if(status==3||status==4){
				if(form.value.zrfqz==""||form.value.gjcs==""){
					ElMessage.error("请负责人签字和并填写改进措施");
					return
				}
			}
		}
		// 任务完成或审核完成时，检查事项类型要求上传文件是否全部完成
		if((status===3||status===4) && requiredUploadNames.value.length > 0){
			if(!checkAllRequiredUploaded()){
				ElMessage.warning('请先上传事项类型要求的所有文件后再保存');
				return;
			}
		}
		// 任务完成或审核完成时，检查签字流程是否全部完成
		if((status===3||status===4) && formInstance.value){
			let allSigned = true;
			for(let i=0;i<formInstanceSteps.value.length;i++){
				let step = formInstanceSteps.value[i];
				if(step.executorsign==='1' && !step.executorsignname){
					allSigned = false;
					break;
				}
				if(step.reviewersign==='1' && !step.reviewersignname){
					allSigned = false;
					break;
				}
			}
			if(!allSigned){
				ElMessage.warning('签字流程尚未全部完成，请先完成所有签字');
				return;
			}
		}
		let addfjArr:any[] = []
		addFileList.value.forEach(val=>{
			let u = '', nm = ''
			if (val.response && val.response.data && val.response.data[0]) {
				u = val.response.data[0].url
				nm = val.response.data[0].name ? decodeURIComponent(val.response.data[0].name) : ''
			} else if (val.url) {
				const idx = val.url.indexOf('|')
				if (idx >= 0) { u = val.url.substring(0, idx); nm = val.url.substring(idx + 1) }
				else { u = val.url }
			}
			addfjArr.push(u + (nm ? '|' + nm : ''))
		})
		if(name != ""){
			updateremark.value = name
		}
		if(updateremark.value === ""){
			ElMessage.error("请输入任务日志");
			return
		}
		requestAddTasklog({
			taskid:form.value.id,
			taskuuid:form.value.uuid,
			updateremark:updateremark.value,
			filelist:addfjArr.join(","),
			stepid:form.value.stepid,
			status:status,
			jlbjrq:jlbjrq.value,
			// 勾选同步复选框时才同步（后端仅对 status=1 提交日志 / status=3 任务完成 生效）
			synctoorder: (syncToOrder.value && isOrderInfoType.value) ? 1 : 0
		}).then((res:any)=>{
			if(res.status === 1){
				ElMessage({
					message: res.msg,
					type: 'success',
					duration: 500
				});
				// getTaskStatus(status);
				setTimeout(()=>{
					if(status!=-1){
						form.value.status = status
					}
					
					updateremark.value = ""
					addfjArr = []
					addFileList.value = []
					getLogList();
				},500)
			}
		})
	}
	const getUserList = () =>{
		xmUser().then((res:any)=>{
			if(res.status === 1){
				userLists.value = res.datalist
			}
		})
	}
	const getUserIdName = () =>{
		return userList.value.id+","+userList.value.name
	} 
	const type1tostring = (val: number) =>{
		if(val==1){
			return  "项目售前"
		}
		if(val==2){
			return  "项目售中"
		}
		if(val==3){
			return  "项目售后"
		}
		if(val==4){
			return  "公司内部项目"
		}
		if(val==5){
			return  "周计划投产"
		}
		
	}
	const getModelingByTaskid = () =>{
		requestGetModelingByTaskid({
			taskid:form.value.id
		}).then((res:any)=>{
			console.log("111111111111111111")
			for(var i=0;i<res.datalist.length;i++){
			console.log("22222222222222")
				var tmp=res.datalist[i];
				var cadimg1=[];
				if(tmp["cadimg"]!=""){ 
					for(var j=0;j<tmp["cadimg"].split(",").length;j++){
						cadimg1.push({response:{data:[{url:tmp["cadimg"].split(",")[j]}]}})
					}
				}
				var cadfile1=[];
				if(tmp["cadfile"]!=""){ 
					for(var j=0;j<tmp["cadfile"].split(",").length;j++){
						cadfile1.push({response:{data:[{url:tmp["cadfile"].split(",")[j]}]}})
					}
				}
				var gsfile1=[];
				if(tmp["gsfile"]!=""){ 
					for(var j=0;j<tmp["gsfile"].split(",").length;j++){
						gsfile1.push({response:{data:[{url:tmp["gsfile"].split(",")[j]}]}})
					}
				}
				console.log(cadimg1)
				console.log(cadfile1)
				console.log(gsfile1)
				modelingList.value.push({
					id:tmp["id"],
					taskid:tmp["taskid"],
					code: tmp["code"], 
					name: tmp["name"], 
					typeid: tmp["typeid"]+"###"+tmp["typename"],
					typename:tmp["typename"],
					cadimg:cadimg1,
					cadfile:cadfile1,
					gsfile:gsfile1,
					remarks:tmp["remarks"],
					pj:tmp["pj"],
				})
			}
		})
	}
	const savemodeling = () =>{
		for(var i = 0; i < modelingList.value.length; i++){
			if(modelingList.value[i].cadimg.length > 0){
				var tmpurl=new Array();
				for(var j = 0; j < modelingList.value[i].cadimg.length; j++){
					tmpurl.push(modelingList.value[i].cadimg[j].response.data[0].url)
				}
				console.log(tmpurl);
				modelingList.value[i].cadimgurl=tmpurl.join(",");
			}else{
				modelingList.value[i].cadimgurl="";
			}

			if(modelingList.value[i].cadfile.length > 0){
				var tmpurl=new Array();
				for(var j = 0; j < modelingList.value[i].cadfile.length; j++){
					tmpurl.push(modelingList.value[i].cadfile[j].response.data[0].url)
				}
				console.log(tmpurl);
				modelingList.value[i].cadfileurl=tmpurl.join(",");
			}else{
				modelingList.value[i].cadfileurl="";
			}

			if(modelingList.value[i].gsfile.length > 0){
				var tmpurl=new Array();
				for(var j = 0; j < modelingList.value[i].gsfile.length; j++){
					tmpurl.push(modelingList.value[i].gsfile[j].response.data[0].url)
				}
				console.log(tmpurl);
				modelingList.value[i].gsfileurl=tmpurl.join(",");
			}else{
				modelingList.value[i].gsfileurl="";
			}
		}
		let jsonString = JSON.stringify(modelingList.value);
		console.log(jsonString);
		requestSaveModeling({
			taskid:form.value.id,
			modelingpath:jsonString
		}).then((res:any)=>{
			if(res.status === 1){
				ElMessage({
					message: res.msg,
					type: 'success',
					duration: 500
				});
			}
		})
	}
	const addmodeling = () =>{ 
		modelingList.value.unshift({
			taskid:'',
			code: '', 
			name: '', 
			typeid: '',
			typename:'',
			cadimg:[],
			cadfile:[],
			gsfile:[],
			remarks:'',
		})
		console.log(modelingList);
	}
	const deletemodelling = (item: any,index: number) =>{
		modelingList.value.splice(index,1)
	}
	//
	const addsubline = (t: any) =>{ 
		subTaskList.value.push({
			id:'0',
			taskid:'',
			typename: t, 
			remarks: '', 
			userid: '',
			username:'',
			checktime:'',
			status:-1,
		})
	}
	const getSubTaskInfoByTaskid = () =>{
		requestGetSubTaskInfo({
			taskid:form.value.id
		}).then((res:any)=>{
			subTaskList.value = res.datalist
		})
	}
	const CheckSubTaskInfo = (item: any,index: number,status: number) =>{ 
		//
		requestCheckSubTaskInfo({
				id:subTaskList.value[index].id,
				status:status
			}).then((res:any)=>{
				if(res.status === 1){
					getSubTaskInfoByTaskid();
				}
			})
	}
	const deletesubline = (item: any,index: number) =>{
		// 判断是不是有id有id要删除数据
		if(subTaskList.value[index] != 0){
			requestDeleteSubTaskInfo({
				id:subTaskList.value[index].id
			}).then((res:any)=>{
				if(res.status === 1){
					subTaskList.value.splice(index,1)
				}
			})
		}else{
			subTaskList.value.splice(index,1)
		}
	}
	const savesubline = () =>{
		//保存后要回显查询一下
		let jsonString = JSON.stringify(subTaskList.value);
		console.log(jsonString);
		requestSaveSubTask({
			taskid:form.value.id,
			subtaskinfo:jsonString
		}).then((res:any)=>{
			if(res.status === 1){
				ElMessage({
					message: res.msg,
					type: 'success',
					duration: 500
				});
				getSubTaskInfoByTaskid();
			}
		})
	}
	const subtaskinfostatus = (item: any) =>{ 
		if(item==0){
			return "待审核"
		}else if(item==1){
			return "审核通过"
		}else if(item==2){
			return "审核未通过"
		}
		return ""
	}

	const updateSjwcFromType4 = () => {
    if (!type4DataList.value || type4DataList.value.length === 0) {
        return;
    }

    // 过滤出完成量大于 0 的项目
    const completedItems = type4DataList.value.filter(item => item.completedQty > 0);

    if (completedItems.length === 0) {
        // 如果都没有完成，可以选择清空或者保留原有非自动生成内容，这里假设清空或不做操作
        // 如果希望保留用户手动输入的其他内容，逻辑会更复杂，这里假设 sjwc 主要由定额任务驱动
        // form.value.sjwc = ""; 
        return;
    }

    // 格式化为 "名称*数量"
    const summaryStrings = completedItems.map(item => {
        return `${item.name}*${item.completedQty}`;
    });

    // 用分号分隔
    const newSjwc = summaryStrings.join('；'); // 使用中文分号，也可改为 ';'

    // 更新 form.sjwc
    // 注意：如果用户可能在 sjwc 中手动输入其他内容，直接赋值会覆盖。
    // 根据需求“对进度行汇总显示”，这里采取直接覆盖策略，或者你可以选择追加模式。
    form.value.sjwc = newSjwc;
};

// 新增：监听 type4DataList 的变化
watch(
    () => type4DataList.value,
    (newVal) => {
        // 当定额任务明细数据发生变化时，重新计算 sjwc
        updateSjwcFromType4();
    },
    { deep: true } // 深度监听，因为数组内部对象的属性变了也需要触发
);

	// ========== 签字流程相关方法 ==========
	// 加载表单模板列表
	const loadFormTemplateList = () => {
		reqFormInstanceTemplateList({}).then((res:any)=>{
			if(res.status === 1){
				formTemplateList.value = res.datalist || [];
			}
		});
	};

	// 加载当前任务的表单实例
	const loadFormInstanceData = () => {
		if(form.value.id){
			reqFormInstanceGetByTask({taskid: form.value.id}).then((res:any)=>{
				if(res.status === 1 && res.datalist){
					formInstance.value = res.datalist.instance;
					formInstanceSteps.value = res.datalist.steps || [];
					formInstanceRejects.value = res.datalist.rejects || [];
					// 初始化每个步骤的附件上传列表
					initStepAttachUploadList();
					// 加载已作废附件，用于给节点附件打作废标记
					loadVoidFiles();
					// 环节数据就绪后，滚动定位到指定环节（由外部传入 focusStepId）
					scrollToFocusStep();
				} else {
					formInstance.value = null;
					formInstanceSteps.value = [];
					formInstanceRejects.value = [];
					stepAttachUploadList.value = [];
				}
			});
		}
	};

	// 滚动并高亮定位到指定环节
	const scrollToFocusStep = () => {
		if (String(props.focusStepId) === '') return;
		nextTick(() => {
			// 延时确保环节 DOM 已渲染完成
			setTimeout(() => {
				const el = document.getElementById('form-step-' + props.focusStepId);
				if (el) {
					el.scrollIntoView({ behavior: 'smooth', block: 'center' });
				}
			}, 300);
		});
	};

	// 由"项目所有附件"跳转进来时，滚动定位到对应区域：
	// tasklog=任务日志（可定位到具体某条日志），taskfile=任务附件，sign=签字流程
	const scrollToFocusTarget = () => {
		const t = String(props.focusTarget || '')
		if (t === '') return
		nextTick(() => {
			setTimeout(() => {
				let el: any = null
				if (t === 'sign') {
					if (String(props.focusStepId) !== '') el = document.getElementById('form-step-' + props.focusStepId)
				} else if (t === 'taskfile') {
					el = document.getElementById('sec-taskfile')
				} else if (t === 'tasklog') {
					// 优先定位到具体那条日志，否则定位到"提交日志"区域
					if (String(props.focusLogId) !== '') el = document.getElementById('tasklog-' + props.focusLogId)
					if (!el) el = document.getElementById('sec-tasklog')
				}
				if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' })
			}, 600)
		})
	};

	// 初始化步骤附件上传列表（用于el-upload回显）
	const initStepAttachUploadList = () => {
		stepAttachUploadList.value = formInstanceSteps.value.map((step:any) => {
			if(!step.stepattach) return [];
			return step.stepattach.split(',').filter((f:string) => f).map((f:string, i:number) => ({
				name: '附件' + (i+1),
				url: f
			}));
		});
	};

	// 创建签字流程
	const createFormInstance = () => {
		if(selectedTemplateId.value === 0){
			ElMessage.warning('请选择表单模板');
			return;
		}
		reqFormInstanceCreate({
			taskid: form.value.id,
			taskuuid: form.value.uuid,
			formid: selectedTemplateId.value
		}).then((res:any)=>{
			if(res.status === 1){
				ElMessage({message: res.msg, type: 'success', duration: 500});
				loadFormInstanceData();
				getLogList();
				// 后端已为流程相关人员自动创建"立即提醒"配置，这里刷新以便立即看到
				loadReminderList();
			} else {
				ElMessage({message: res.msg || '创建失败', type: 'error', duration: 500});
			}
		});
	};

	// 删除签字流程
	const deleteFormInstance = () => {
		ElMessageBox.confirm('确定要删除当前签字流程吗？删除后可重新选择模板。', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(() => {
			reqFormInstanceDelete({
				instanceid: formInstance.value.id,
				taskuuid: form.value.uuid
			}).then((res:any)=>{
				if(res.status === 1){
					ElMessage({message: '删除成功', type: 'success', duration: 500});
					formInstance.value = null;
					formInstanceSteps.value = [];
					selectedTemplateId.value = 0;
					getLogList();
				}
			});
		}).catch(() => {});
	};

	// 保存节点数据（附件/完成时间/结论）
	const saveStepData = (step: any) => {
		reqFormInstanceSaveStepData({
			stepid: step.id,
			stepattach: step.stepattach || '',
			steptime: step.steptime || '',
			stepconclusion: step.stepconclusion || ''
		}).then((res:any)=>{
			if(res.status === 1){
				ElMessage({message: '保存成功', type: 'success', duration: 500});
			} else {
				ElMessage({message: res.msg || '保存失败', type: 'error', duration: 500});
			}
		});
	};

	// 节点附件上传成功
	const onStepAttachSuccess = (step: any, idx: number, res: any, file: any, fileList: any) => {
		console.log(res);
		if(res.errno === 0 && res.data && res.data[0]){
			const newUrl = res.data[0].url;
			console.log(newUrl)
			let attachArr = step.stepattach ? step.stepattach.split(',').filter((f:string) => f) : [];
			attachArr.push(newUrl);
			console.log(attachArr)
			step.stepattach = attachArr.join(',');
			console.log(step)
			// 更新上传列表
			//if(!stepAttachUploadList.value[idx]) stepAttachUploadList.value[idx] = [];
			//stepAttachUploadList.value[idx].push({name: file.name, url: newUrl});
		}
	};

	// 节点附件移除
	const onStepAttachRemove = (step: any, idx: number, file: any, fileList: any) => {
		let attachArr = step.stepattach ? step.stepattach.split(',').filter((f:string) => f) : [];
		// 移除对应文件
		if(file.url){
			attachArr = attachArr.filter((f:string) => f !== file.url);
		}
		step.stepattach = attachArr.join(',');
		// 更新上传列表
		stepAttachUploadList.value[idx] = fileList.map((f:any) => ({name: f.name, url: f.url || (f.response && f.response.data && f.response.data[0] && f.response.data[0].url) || ''}));
		};

		// ===== 完善项目信息 / 项目所有附件（与项目管理页操作一致）=====
const projectInfoShow = ref<boolean>(false)
const projectInfoRef = ref<any>(null)
const projectInfoSaving = ref<boolean>(false)
const allFilesRef = ref<any>(null)
const openProjectInfo = () => {
	if(!projectobj.value || !projectobj.value.uuid){
		ElMessage.warning('未获取到项目信息，请稍候重试')
		return
	}
	projectInfoShow.value = true
	nextTick(() => { if(projectInfoRef.value) projectInfoRef.value.load() })
}
const saveProjectInfo = () => {
	if(!projectInfoRef.value) return
	projectInfoSaving.value = true
	projectInfoRef.value.save()
	setTimeout(() => { projectInfoSaving.value = false }, 800)
}
const onProjectInfoSaved = () => {
	projectInfoShow.value = false
	projectInfoSaving.value = false
}
const openAllFiles = () => {
	if(!projectobj.value || !projectobj.value.uuid){
		ElMessage.warning('未获取到项目信息，请稍候重试')
		return
	}
	if(allFilesRef.value) allFilesRef.value.open(projectobj.value.uuid, projectobj.value.projectname || form.value.projectname)
}

// ===== 附件 Ctrl + V 粘贴上传 =====
		// 本页有多处附件上传（建模 cad照片/cad文件/公式文件、签字流程节点附件、提交日志附件），
		// 以“最近点击过的上传区域”作为粘贴目标，避免粘贴到错误的栏目
		const pasteTarget = ref<any>({ type: 'log', idx: -1, field: '' })
		const pasteUploading = ref<boolean>(false)
		const setPasteTarget = (type: string, idx: number = -1, field: string = '') => {
		if (pasteTarget.value.type === type && pasteTarget.value.idx === idx && pasteTarget.value.field === field) return
		pasteTarget.value = { type, idx, field }
		}
		// 判断某个上传区域是否为当前粘贴目标（用于高亮）
		const isPasteTarget = (type: string, idx: number = -1, field: string = '') => {
		const t = pasteTarget.value
		return t.type === type && t.idx === idx && t.field === field
		}
		// 当前粘贴目标的中文名称（页面右下角提示，避免粘错栏目）
		const pasteTargetName = computed(() => {
		const t = pasteTarget.value
		if (t.type === 'log') return '提交日志附件'
		if (t.type === 'step') {
			const step: any = formInstanceSteps.value[t.idx]
			return '节点附件（环节' + (t.idx + 1) + (step && step.stepdesc ? '：' + step.stepdesc : '') + '）'
		}
		if (t.type === 'model') {
			const names: any = { cadimg: '建模-cad照片', cadfile: '建模-cad文件', gsfile: '建模-公式文件' }
			return names[t.field] || '建模附件'
		}
		return '未选择'
		})
		// 把已上传的附件写入对应栏目（各栏目数据结构不同，分别处理）
		const applyPastedFile = (t: any, url: string, name: string, rawName: string) => {
		if (!url) return
		if (t.type === 'log') {
			// 用 concat 而非展开语法：项目 tslib 版本较旧，缺少 __spreadArray 帮助器
		addFileList.value = addFileList.value.concat([{ name, url, response: { data: [{ url, name: rawName }] } }])
		} else if (t.type === 'step') {
			const step: any = formInstanceSteps.value[t.idx]
			if (!step) return
			// 节点附件以逗号分隔的 url 串保存在 step.stepattach，需点击“保存附件”持久化
			const arr: string[] = step.stepattach ? step.stepattach.split(',').filter((f: string) => f) : []
			arr.push(url)
			step.stepattach = arr.join(',')
		} else if (t.type === 'model') {
			const item: any = modelingList.value[t.idx]
			if (!item) return
			const key = t.field
			// 用 concat 而非展开语法：项目 tslib 版本较旧，缺少 __spreadArray 帮助器
			const arr = (Array.isArray(item[key]) ? item[key] : []).concat()
			arr.push({ name, response: { data: [{ url, name: rawName }] } })
			item[key] = arr
		}
		}
		// 上传单个粘贴文件（与 el-upload 走同一接口 /frame/uploadfile1，表单字段名 file）
		const uploadPasteFile = (t: any, file: File) => {
		if (t.type === 'log' && Number(form.value.status) === 0) {
			ElMessage.warning('任务未启动，无法上传附件')
			return
		}
		pasteUploading.value = true
		const fd = new FormData()
		fd.append('file', file, file.name || ('paste_' + Date.now()))
		fetch(`${apiname.value}/frame/uploadfile1`, { method: 'POST', credentials: 'same-origin', body: fd })
			.then((r: any) => r.json())
			.then((res: any) => {
				if (res && res.errno === 0 && res.data && res.data[0]) {
					const rawName = res.data[0].name || ''
					const name = rawName ? decodeURIComponent(rawName) : (file.name || '附件')
					applyPastedFile(t, res.data[0].url, name, rawName)
					ElMessage({ message: '附件已上传', type: 'success', duration: 800 })
				} else {
					ElMessage({ message: (res && res.msg) || '附件上传失败', type: 'error', duration: 800 })
				}
			})
			.catch(() => {
				ElMessage({ message: '附件上传失败', type: 'error', duration: 800 })
			})
			.finally(() => {
				pasteUploading.value = false
			})
		}
		// 全局粘贴：剪贴板中带文件时上传；纯文本粘贴不拦截，不影响输入框正常粘贴
		const onPaste = (e: ClipboardEvent) => {
		// 新建任务弹窗打开时交给 AddTask 自己处理，避免同一个附件被上传两次
		if (addShowTask.value) return
		const items = e.clipboardData && e.clipboardData.items
		if (!items) return
		const files: File[] = []
		for (let i = 0; i < items.length; i++) {
			const it: any = items[i]
			if (it && it.kind === 'file' && it.getAsFile) {
				const f = it.getAsFile()
				if (f) files.push(f)
			}
		}
		if (files.length === 0) return
		e.preventDefault()
		const t = pasteTarget.value
		files.forEach((f: File) => uploadPasteFile(t, f))
		}

		onBeforeUnmount(() => {
		document.removeEventListener('paste', onPaste)
		})

	// 删除签字流程环节
	const deleteStep = (step: any) => {
		ElMessageBox.confirm(`确定要删除环节“${step.stepdesc}”吗？删除后不可恢复。`, '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(() => {
			reqFormInstanceDeleteStep({
				stepid: step.id,
				instanceid: formInstance.value.id,
				taskuuid: form.value.uuid
			}).then((res:any)=>{
				if(res.status === 1){
					ElMessage({message: res.msg, type: 'success', duration: 500});
					loadFormInstanceData();
					getLogList();
				} else {
					ElMessage({message: res.msg || '删除失败', type: 'error', duration: 500});
				}
			});
		}).catch(() => {});
	};

	// 执行人签字
	const executorSign = (step: any) => {
		// 前置条件校验（节点级）
		if(step.needattach === '1' && !step.stepattach){
			ElMessage.warning('该环节要求上传附件，请先在节点中上传附件');
			return;
		}
		if(step.needtime === '1' && !step.steptime){
			ElMessage.warning('该环节要求设置完成时间，请先设置节点完成时间');
			return;
		}
		if(step.executorconclusion === '1' && !step.stepconclusion){
			ElMessage.warning('该环节要求填写结论，请先填写节点结论');
			return;
		}
		ElMessageBox.confirm('确认执行人签字吗？', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'info'
		}).then(() => {
			reqFormInstanceExecutorSign({
				stepid: step.id,
				instanceid: formInstance.value.id,
				taskuuid: form.value.uuid,
				signname: userList.value.name
			}).then((res:any)=>{
				if(res.status === 1){
					ElMessage({message: res.msg, type: 'success', duration: 500});
					loadFormInstanceData();
					getLogList();
					// 刷新任务执行人/审核人（签字流程按规则同步后即时回显）
					toTask(form.value.id);
				} else {
					ElMessage({message: res.msg || '签字失败', type: 'error', duration: 1500});
				}
			});
		}).catch(() => {});
	};

	// 审核人签字
	const reviewerSign = (step: any) => {
		ElMessageBox.confirm('确认审核人签字吗？', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'info'
		}).then(() => {
			reqFormInstanceReviewerSign({
				stepid: step.id,
				instanceid: formInstance.value.id,
				taskuuid: form.value.uuid,
				signname: userList.value.name
			}).then((res:any)=>{
				if(res.status === 1){
					ElMessage({message: res.msg, type: 'success', duration: 500});
					loadFormInstanceData();
					getLogList();
					// 刷新任务执行人/审核人（签字流程按规则同步后即时回显）
					toTask(form.value.id);
				} else {
					ElMessage({message: res.msg || '签字失败', type: 'error', duration: 1500});
				}
			});
		}).catch(() => {});
	};

	// 当前用户是否为该环节需要签字的人（且尚未签字）
	const isStepPendingSigner = (step: any) => {
		const me = userList.value && userList.value.name
		if (!me) return false
		const isExecutor = step.executor === me && step.executorsign === '1' && !step.executorsignname
		const isReviewer = step.reviewer === me && step.reviewersign === '1' && !step.reviewersignname
		return isExecutor || isReviewer
	}
	// 该环节是否为当前可签字环节（其前面的环节均已签字完成）
	const isStepReachable = (step: any) => {
		const order = Number(step.steporder)
		return formInstanceSteps.value
			.filter((s:any) => Number(s.steporder) < order)
			.every((s:any) => {
				const exDone = s.executor === '' || s.executorsign === '0' || s.executorsignname !== ''
				const rvDone = s.reviewer === '' || s.reviewersign === '0' || s.reviewersignname !== ''
				return exDone && rvDone
			})
	}
	// 当前用户能否驳回该环节（需为当前可签字环节的人员，且存在上一道环节）
	const canRejectStep = (step: any) => {
		if (!isStepPendingSigner(step)) return false
		if (!isStepReachable(step)) return false
		const order = Number(step.steporder)
		return formInstanceSteps.value.some((s:any) => Number(s.steporder) < order)
	}
	// 取该环节最近一次被驳回的记录（驳回人/时间/原因）
	const rejectInfoForStep = (step: any) => {
		const list = formInstanceRejects.value || []
		return list.find((x:any) => Number(x.stepid) === Number(step.id)) || null
	}

	// 驳回弹窗
	const rejectDialogVisible = ref<boolean>(false)
	const rejectTargetStep = ref<any>(null)
	const rejectReason = ref<string>('')
	const rejectType = ref<'prev' | 'current'>('prev') // prev=退回上一道环节；current=审核人驳回执行人提交
	const canRejectExecutor = (step: any) => {
		const me = userList.value && userList.value.name
		if (!me) return false
		// 当前用户是该环节审核人、审核人需签字、审核人尚未签字
		if (step.reviewer !== me || step.reviewersign !== '1' || step.reviewersignname) return false
		// 执行人必须已签字（才有可驳回的提交）
		if (step.executorsign !== '1' || !step.executorsignname) return false
		// 当前环节需为可签字环节
		if (!isStepReachable(step)) return false
		return true
	}
	const openReject = (step: any) => {
		rejectType.value = 'prev'
		rejectTargetStep.value = step
		rejectReason.value = ''
		rejectDialogVisible.value = true
	}
	const openRejectExecutor = (step: any) => {
		rejectType.value = 'current'
		rejectTargetStep.value = step
		rejectReason.value = ''
		rejectDialogVisible.value = true
	}
	const confirmReject = () => {
		if (!rejectReason.value || !rejectReason.value.trim()) {
			ElMessage.warning('请填写驳回原因')
			return
		}
		if (!rejectTargetStep.value || !formInstance.value) return
		const params = {
			stepid: rejectTargetStep.value.id,
			instanceid: formInstance.value.id,
			taskuuid: form.value.uuid,
			rejectreason: rejectReason.value.trim()
		}
		const api = rejectType.value === 'current' ? reqFormInstanceRejectCurrent : reqFormInstanceReject
		api(params).then((res:any) => {
			if (res.status === 1) {
				ElMessage({ message: res.msg || '已驳回', type: 'success', duration: 1000 })
				rejectDialogVisible.value = false
				loadFormInstanceData()
				getLogList()
			} else {
				ElMessage({ message: res.msg || '操作失败', type: 'error', duration: 1500 })
			}
		})
	}

	// ========== 提醒配置相关方法 ==========
	// 钉钉工作通知推送类型：仅这两类可自定义提醒内容
	const isDDWorkType = (t: any) => t === 'ddwork' || t === 'ddwork_scheduled'
	// 加载提醒列表
	const loadReminderList = () => {
		if(!form.value.id) return;
		requestGetTaskReminderList({taskid: form.value.id}).then((res:any)=>{
			if(res.status === 1){
				// reminduser 以逗号存储，转成数组供多选组件使用
				reminderList.value = (res.datalist || []).map((r:any)=>Object.assign({}, r, {
					remindusers: String(r.reminduser || '').split(',').filter((v:string)=>v),
					content: r.content || ''
				}));
			}
		});
	};
	// 添加提醒项
	const addReminder = () => {
		reminderList.value.push({
			id: 0,
			taskid: form.value.id,
			remindusers: [],
			remindtime: '',
			remindtype: 'scheduled',
			content: '',
			status: '0'
		});
	};
	// 保存提醒项
	const saveReminder = (item: any) => {
		const users = item.remindusers || []
		if(users.length === 0){
			ElMessage.warning('请选择提醒人');
			return;
		}
		if((item.remindtype === 'scheduled' || item.remindtype === 'ddwork_scheduled') && !item.remindtime){
			ElMessage.warning('请选择提醒时间');
			return;
		}
		requestSaveTaskReminder({
			id: item.id,
			taskid: form.value.id,
			taskuuid: form.value.uuid,
			reminduser: users.join(','),
			remindtime: item.remindtime,
			remindtype: item.remindtype || 'scheduled',
			// 语音推送不传自定义内容，仅钉钉工作通知推送生效
			content: isDDWorkType(item.remindtype) ? (item.content || '') : ''
		}).then((res:any)=>{
			if(res.status === 1){
				const tip = item.remindtype==='ddwork' ? '已发送钉钉工作通知'
					: (item.remindtype==='ddwork_scheduled' ? '保存成功，将在设定时间推送钉钉工作通知'
					: (item.remindtype==='immediate' ? '已立即发送提醒' : '保存成功'))
				ElMessage({message: tip, type: 'success', duration: 500});
				loadReminderList();
			} else {
				ElMessage({message: res.msg || '保存失败', type: 'error', duration: 500});
			}
		});
	};
	// 删除提醒项
	const deleteReminder = (item: any, index: number) => {
		if(item.id && item.id != 0){
			requestDeleteTaskReminder({id: item.id}).then((res:any)=>{
				if(res.status === 1){
					ElMessage({message: '删除成功', type: 'success', duration: 500});
					reminderList.value.splice(index, 1);
				}
			});
		} else {
			reminderList.value.splice(index, 1);
		}
	};
	// 标记提醒为已读
	const markReminderRead = (item: any) => {
		requestMarkReminderRead({id: item.id}).then((res:any)=>{
			if(res.status === 1){
				item.readstatus = '1';
				item.readtime = res.readtime || '';
				ElMessage({message: '已标记为已读', type: 'success', duration: 500});
			}
		});
	};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_PriceTag = _resolveComponent("PriceTag")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_AlarmClock = _resolveComponent("AlarmClock")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_Timer = _resolveComponent("Timer")!
  const _component_user = _resolveComponent("user")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Help = _resolveComponent("Help")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_Edit = _resolveComponent("Edit")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_Document = _resolveComponent("Document")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_WarningFilled = _resolveComponent("WarningFilled")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_Warning = _resolveComponent("Warning")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_Close = _resolveComponent("Close")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_descriptions, {
        column: 2,
        border: "",
        title: ""
      }, {
        title: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, "（" + _toDisplayString(projectobj.value.code) + "-" + _toDisplayString(form.value.projectname) + "）", 1),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_el_button, {
                size: "small",
                type: "success",
                onClick: openProjectInfo
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                size: "small",
                type: "warning",
                onClick: openAllFiles
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              })
            ])
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_descriptions_item, null, {
            label: _withCtx(() => [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_el_icon, { style: {"margin-right":"3px"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_PriceTag)
                  ]),
                  _: 1
                }),
                _hoisted_10
              ])
            ]),
            default: _withCtx(() => [
              _createTextVNode(" " + _toDisplayString(type1tostring(projectobj.value.type1)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, null, {
            label: _withCtx(() => [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_el_icon, { style: {"margin-right":"3px"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_PriceTag)
                  ]),
                  _: 1
                }),
                _hoisted_12
              ])
            ]),
            default: _withCtx(() => [
              _createTextVNode(" " + _toDisplayString(form.value.type1), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, null, {
            label: _withCtx(() => [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_el_icon, { style: {"margin-right":"3px"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_PriceTag)
                  ]),
                  _: 1
                }),
                _hoisted_14
              ])
            ]),
            default: _withCtx(() => [
              _createTextVNode(" " + _toDisplayString(form.value.jmtype), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, null, {
            label: _withCtx(() => [
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_el_icon, { style: {"margin-right":"3px"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_PriceTag)
                  ]),
                  _: 1
                }),
                _hoisted_16
              ])
            ]),
            default: _withCtx(() => [
              _createTextVNode(" " + _toDisplayString(form.value.type2), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, null, {
            label: _withCtx(() => [
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_el_icon, { style: {"margin-right":"3px"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_PriceTag)
                  ]),
                  _: 1
                }),
                _hoisted_18
              ])
            ]),
            default: _withCtx(() => [
              _createTextVNode(" " + _toDisplayString(form.value.nowjl) + "/" + _toDisplayString(form.value.maxjl) + "(" + _toDisplayString(form.value.maxjlgs) + "小时) ", 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, null, {
            label: _withCtx(() => [
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_el_icon, { style: {"margin-right":"3px"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_AlarmClock)
                  ]),
                  _: 1
                }),
                _hoisted_20
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_component_el_date_picker, {
                  modelValue: form.value.startdate,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.startdate) = $event)),
                  type: "date",
                  placeholder: "开始时间",
                  "value-format": "YYYY-MM-DD",
                  size: "small",
                  style: {"width":"100px"}
                }, null, 8, ["modelValue"]),
                _createVNode(_component_el_button, {
                  type: "primary",
                  size: "small",
                  onClick: saveStartTime,
                  style: {"margin-left":"5px"}
                }, {
                  default: _withCtx(() => [
                    _hoisted_21
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, null, {
            label: _withCtx(() => [
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_component_el_icon, { style: {"margin-right":"3px"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Timer)
                  ]),
                  _: 1
                }),
                _hoisted_23
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_component_el_date_picker, {
                  modelValue: form.value.enddate,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.enddate) = $event)),
                  type: "date",
                  placeholder: "结束时间",
                  "value-format": "YYYY-MM-DD",
                  size: "small",
                  style: {"width":"100px"}
                }, null, 8, ["modelValue"]),
                _createVNode(_component_el_button, {
                  type: "primary",
                  size: "small",
                  onClick: saveEndTime,
                  style: {"margin-left":"5px"}
                }, {
                  default: _withCtx(() => [
                    _hoisted_24
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, null, {
            label: _withCtx(() => [
              _createElementVNode("div", _hoisted_25, [
                _createVNode(_component_el_icon, { style: {"margin-right":"3px"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_user)
                  ]),
                  _: 1
                }),
                _hoisted_26
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_component_el_select, {
                  onChange: _cache[2] || (_cache[2] = ($event: any) => (changeZxr())),
                  size: "small",
                  filterable: "",
                  modelValue: zxr.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((zxr).value = $event)),
                  placeholder: "请选择",
                  style: {"width":"100px"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userLists.value, (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: item.name,
                        value: `${item.id},${item.name}`,
                        key: index
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, null, {
            label: _withCtx(() => [
              _createElementVNode("div", _hoisted_27, [
                _createVNode(_component_el_icon, { style: {"margin-right":"3px"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_user)
                  ]),
                  _: 1
                }),
                _hoisted_28
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_component_el_select, {
                  onChange: _cache[4] || (_cache[4] = ($event: any) => (changeShr())),
                  size: "small",
                  filterable: "",
                  modelValue: shr.value,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((shr).value = $event)),
                  placeholder: "请选择",
                  style: {"width":"100px"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userLists.value, (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: item.name,
                        value: `${item.id},${item.name}`,
                        key: index
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, null, {
            label: _withCtx(() => [
              _createElementVNode("div", _hoisted_29, [
                _createVNode(_component_el_icon, { style: {"margin-right":"3px"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_user)
                  ]),
                  _: 1
                }),
                _hoisted_30
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_component_el_select, {
                  modelValue: taskStartUserid.value,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((taskStartUserid).value = $event)),
                  filterable: "",
                  "allow-create": "",
                  "default-first-option": "",
                  size: "small",
                  placeholder: "请选择启动人",
                  style: {"width":"120px"},
                  disabled: !canStartTask.value,
                  onChange: changeStartUser
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(startUsers.value, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.name,
                        value: Number(item.id)
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"]),
                (!canStartTask.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_31, "（仅启动任务权限用户可修改）"))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, null, {
            label: _withCtx(() => [
              _createElementVNode("div", _hoisted_32, [
                _createVNode(_component_el_icon, { style: {"margin-right":"3px"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_PriceTag)
                  ]),
                  _: 1
                }),
                _hoisted_33
              ])
            ]),
            default: _withCtx(() => [
              _createTextVNode(" " + _toDisplayString(form.value.tasktitle), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, null, {
            label: _withCtx(() => [
              _createElementVNode("div", _hoisted_34, [
                _createVNode(_component_el_icon, { style: {"margin-right":"3px"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Help)
                  ]),
                  _: 1
                }),
                _hoisted_35
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: statusSelect.value,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((statusSelect).value = $event)),
                size: "small",
                disabled: !isTaskStarter.value,
                onChange: getTaskStatus,
                style: {"width":"140px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: _unref(getStatus)(0),
                    value: 0
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_option, {
                    label: _unref(getStatus)(1),
                    value: 1
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_option, {
                    label: _unref(getStatus)(2),
                    value: 2
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_option, {
                    label: _unref(getStatus)(3),
                    value: 3
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_option, {
                    label: _unref(getStatus)(4),
                    value: 4
                  }, null, 8, ["label"])
                ]),
                _: 1
              }, 8, ["modelValue", "disabled"]),
              (!isTaskStarter.value)
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 0,
                    type: "info",
                    size: "small",
                    style: {"margin-left":"8px"}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_36
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, null, {
            label: _withCtx(() => [
              _createElementVNode("div", _hoisted_37, [
                _createVNode(_component_el_icon, { style: {"margin-right":"3px"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Timer)
                  ]),
                  _: 1
                }),
                _hoisted_38
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: form.value.operatorplanendtime,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.value.operatorplanendtime) = $event)),
                onChange: _cache[9] || (_cache[9] = ($event: any) => (changeoperatorplanendtime())),
                type: "date",
                placeholder: "开始时间",
                "value-format": "YYYY-MM-DD",
                style: {"width":"100px"}
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, null, {
            label: _withCtx(() => [
              _createElementVNode("div", _hoisted_39, [
                _createVNode(_component_el_icon, { style: {"margin-right":"3px"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Help)
                  ]),
                  _: 1
                }),
                _hoisted_40
              ])
            ]),
            default: _withCtx(() => [
              _createTextVNode(" " + _toDisplayString(form.value.operatorreadtime), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, null, {
            label: _withCtx(() => [
              _createElementVNode("div", _hoisted_41, [
                _createVNode(_component_el_icon, { style: {"margin-right":"3px"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Help)
                  ]),
                  _: 1
                }),
                _hoisted_42
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_43, [
                _createVNode(_component_el_button, {
                  type: "success",
                  size: "small",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (setOnTime(1)))
                }, {
                  default: _withCtx(() => [
                    _hoisted_44
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  type: "danger",
                  size: "small",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (setOnTime(2))),
                  style: {"margin-left":"8px"}
                }, {
                  default: _withCtx(() => [
                    _hoisted_45
                  ]),
                  _: 1
                }),
                (form.value.ontimeflag=='1')
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 0,
                      type: "success",
                      size: "small",
                      style: {"margin-left":"10px"}
                    }, {
                      default: _withCtx(() => [
                        _hoisted_46
                      ]),
                      _: 1
                    }))
                  : (form.value.ontimeflag=='2')
                    ? (_openBlock(), _createBlock(_component_el_tag, {
                        key: 1,
                        type: "danger",
                        size: "small",
                        style: {"margin-left":"10px"}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_47
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_el_tag, {
                        key: 2,
                        type: "info",
                        size: "small",
                        style: {"margin-left":"10px"}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_48
                        ]),
                        _: 1
                      }))
              ]),
              (form.value.ontimeflag=='2' && form.value.ontimereason)
                ? (_openBlock(), _createElementBlock("div", _hoisted_49, " 反馈原因：" + _toDisplayString(form.value.ontimereason), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, null, {
            label: _withCtx(() => [
              _createElementVNode("div", _hoisted_50, [
                _createVNode(_component_el_icon, { style: {"margin-right":"3px"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Help)
                  ]),
                  _: 1
                }),
                _hoisted_51
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_52, [
                (form.value.reportflag!='1')
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      type: "primary",
                      size: "small",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (setReport(1)))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_53
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createVNode(_component_el_tag, {
                        type: "success",
                        size: "small"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("已汇报：" + _toDisplayString(form.value.reporttime || '-'), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_button, {
                        type: "danger",
                        size: "small",
                        style: {"margin-left":"8px"},
                        onClick: _cache[13] || (_cache[13] = ($event: any) => (setReport(0)))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_54
                        ]),
                        _: 1
                      })
                    ], 64)),
                (form.value.reportflag!='1')
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 2,
                      type: "info",
                      size: "small",
                      style: {"margin-left":"10px"}
                    }, {
                      default: _withCtx(() => [
                        _hoisted_55
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, null, {
            label: _withCtx(() => [
              _createElementVNode("div", _hoisted_56, [
                _createVNode(_component_el_icon, { style: {"margin-right":"3px"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_user)
                  ]),
                  _: 1
                }),
                _hoisted_57
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_component_el_select, {
                  onChange: _cache[14] || (_cache[14] = ($event: any) => (changepriority())),
                  size: "small",
                  filterable: "",
                  modelValue: priority2.value,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((priority2).value = $event)),
                  placeholder: "请选择",
                  style: {"width":"100px"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(priorityLists.value, (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: item,
                        value: `${item}`,
                        key: index
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, null, {
            label: _withCtx(() => [
              _createElementVNode("div", _hoisted_58, [
                _createVNode(_component_el_icon, { style: {"margin-right":"3px"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_user)
                  ]),
                  _: 1
                }),
                _hoisted_59
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_component_el_select, {
                  onChange: _cache[16] || (_cache[16] = ($event: any) => (changeadd())),
                  size: "small",
                  filterable: "",
                  modelValue: isaddotheros.value,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((isaddotheros).value = $event)),
                  placeholder: "请选择",
                  style: {"width":"100px"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(otherosLists.value, (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: item,
                        value: `${item}`,
                        key: index
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, null, {
            label: _withCtx(() => [
              _createElementVNode("div", _hoisted_60, [
                _createVNode(_component_el_icon, { style: {"margin-right":"3px"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_user)
                  ]),
                  _: 1
                }),
                _hoisted_61
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_component_el_switch, {
                  modelValue: isurgent.value,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((isurgent).value = $event)),
                  "active-value": "是",
                  "inactive-value": "否",
                  onChange: changeurgent
                }, null, 8, ["modelValue"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, null, {
            label: _withCtx(() => [
              _createElementVNode("div", _hoisted_62, [
                _createVNode(_component_el_icon, { style: {"margin-right":"3px"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Timer)
                  ]),
                  _: 1
                }),
                _hoisted_63
              ])
            ]),
            default: _withCtx(() => [
              _createTextVNode(" " + _toDisplayString(form.value.actime), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, null, {
            label: _withCtx(() => [
              _createElementVNode("div", _hoisted_64, [
                _createVNode(_component_el_icon, { style: {"margin-right":"3px"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Timer)
                  ]),
                  _: 1
                }),
                _hoisted_65
              ])
            ]),
            default: _withCtx(() => [
              _createTextVNode(" " + _toDisplayString(_unref(getpj)(form.value.pj)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, null, {
            label: _withCtx(() => [
              _createElementVNode("div", _hoisted_66, [
                _createVNode(_component_el_icon, { style: {"margin-right":"3px"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Timer)
                  ]),
                  _: 1
                }),
                _hoisted_67
              ])
            ]),
            default: _withCtx(() => [
              _createTextVNode(" " + _toDisplayString(form.value.lyname), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, null, {
            label: _withCtx(() => [
              _createElementVNode("div", _hoisted_68, [
                _createVNode(_component_el_icon, { style: {"margin-right":"3px"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Timer)
                  ]),
                  _: 1
                }),
                _hoisted_69
              ])
            ]),
            default: _withCtx(() => [
              _createTextVNode(" " + _toDisplayString(form.value.ly), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_descriptions_item, { span: 2 }, {
            label: _withCtx(() => [
              _createElementVNode("div", _hoisted_70, [
                _createVNode(_component_el_icon, { style: {"margin-right":"3px"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Edit)
                  ]),
                  _: 1
                }),
                _hoisted_71
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                autosize: {minRows: 2},
                type: "textarea",
                modelValue: form.value.remarks,
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((form.value.remarks) = $event)),
                onBlur: saveRemarks,
                placeholder: "请输入备注"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (form.value.type1=='售前-建模')
        ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
            _hoisted_73,
            _hoisted_74,
            _createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: _cache[20] || (_cache[20] = ($event: any) => (addmodeling())),
              style: {"margin-top":"10px","margin-bottom":"10px"}
            }, {
              default: _withCtx(() => [
                _hoisted_75
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: _cache[21] || (_cache[21] = ($event: any) => (savemodeling())),
              style: {"margin-top":"10px","margin-bottom":"10px"}
            }, {
              default: _withCtx(() => [
                _hoisted_76
              ]),
              _: 1
            }),
            _hoisted_77,
            _createVNode(_component_el_timeline, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modelingList.value, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_timeline_item, {
                    center: "",
                    placement: "top",
                    key: index
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_card, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            onClick: ($event: any) => (deletemodelling(item,index)),
                            round: "",
                            style: {"background-color":"#f56c6c","color":"#fff","float":"right"}
                          }, {
                            default: _withCtx(() => [
                              _hoisted_78
                            ]),
                            _: 2
                          }, 1032, ["onClick"]),
                          _withDirectives(_createElementVNode("input", {
                            type: "hidden",
                            "onUpdate:modelValue": ($event: any) => ((item.taskid) = $event)
                          }, null, 8, _hoisted_79), [
                            [_vModelText, item.taskid]
                          ]),
                          _createVNode(_component_el_input, {
                            modelValue: item.code,
                            "onUpdate:modelValue": ($event: any) => ((item.code) = $event),
                            placeholder: "请输入统一编号",
                            style: {"width":"150px","margin-top":"10px"}
                          }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                          _createVNode(_component_el_input, {
                            modelValue: item.name,
                            "onUpdate:modelValue": ($event: any) => ((item.name) = $event),
                            placeholder: "请输入名称",
                            style: {"width":"150px","margin-top":"10px"}
                          }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                          _createVNode(_component_el_select, {
                            filterable: "",
                            modelValue: item.typeid,
                            "onUpdate:modelValue": ($event: any) => ((item.typeid) = $event),
                            placeholder: "请选择",
                            style: {"width":"300px","margin-top":"10px"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modelingpathLists.value, (item, index) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  label: item.allname,
                                  value: `${item.allid}###${item.allname}`,
                                  key: index
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["modelValue", "onUpdate:modelValue"]),
                          _hoisted_80,
                          _createElementVNode("div", _hoisted_81, [
                            _createElementVNode("div", _hoisted_82, [
                              _hoisted_83,
                              _createVNode(_component_el_upload, {
                                action: `${apiname.value}/frame/uploadfile1`,
                                "file-list": item.cadimg,
                                onClick: ($event: any) => (setPasteTarget('model', index, 'cadimg')),
                                class: _normalizeClass({'paste_target':isPasteTarget('model',index,'cadimg')})
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_button, {
                                    type: "primary",
                                    size: "small"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_84
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 2
                              }, 1032, ["action", "file-list", "onClick", "class"]),
                              _createElementVNode("div", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.cadimg, (v, i) => {
                                  return (_openBlock(), _createElementBlock("a", {
                                    href: `${apiname.value}${v.response.data[0].url}`,
                                    target: "_blank",
                                    key: i,
                                    style: {"margin-right":"10px"}
                                  }, [
                                    _createElementVNode("img", {
                                      src: `${apiname.value}${v.response.data[0].url}`,
                                      style: {"width":"30px","height":"30px"}
                                    }, null, 8, _hoisted_86)
                                  ], 8, _hoisted_85))
                                }), 128))
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_87, [
                            _createElementVNode("div", _hoisted_88, [
                              _hoisted_89,
                              _createVNode(_component_el_upload, {
                                action: `${apiname.value}/frame/uploadfile1`,
                                "file-list": item.cadfile,
                                onClick: ($event: any) => (setPasteTarget('model', index, 'cadfile')),
                                class: _normalizeClass({'paste_target':isPasteTarget('model',index,'cadfile')})
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_button, {
                                    type: "primary",
                                    size: "small"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_90
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 2
                              }, 1032, ["action", "file-list", "onClick", "class"]),
                              _createElementVNode("div", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.cadfile, (v, i) => {
                                  return (_openBlock(), _createElementBlock("a", {
                                    href: `${apiname.value}${v.response.data[0].url}`,
                                    target: "_blank",
                                    key: i,
                                    style: {"margin-right":"10px"}
                                  }, [
                                    _createVNode(_component_el_icon, {
                                      size: 36,
                                      color: "#409EFF"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Document)
                                      ]),
                                      _: 1
                                    })
                                  ], 8, _hoisted_91))
                                }), 128))
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_92, [
                            _createElementVNode("div", _hoisted_93, [
                              _hoisted_94,
                              _createVNode(_component_el_upload, {
                                action: `${apiname.value}/frame/uploadfile1`,
                                "file-list": item.gsfile,
                                onClick: ($event: any) => (setPasteTarget('model', index, 'gsfile')),
                                class: _normalizeClass({'paste_target':isPasteTarget('model',index,'gsfile')})
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_button, {
                                    type: "primary",
                                    size: "small"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_95
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 2
                              }, 1032, ["action", "file-list", "onClick", "class"]),
                              _createElementVNode("div", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.gsfile, (v, i) => {
                                  return (_openBlock(), _createElementBlock("a", {
                                    href: `${apiname.value}${v.response.data[0].url}`,
                                    target: "_blank",
                                    key: i,
                                    style: {"margin-right":"10px"}
                                  }, [
                                    _createVNode(_component_el_icon, {
                                      size: 36,
                                      color: "#409EFF"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Document)
                                      ]),
                                      _: 1
                                    })
                                  ], 8, _hoisted_96))
                                }), 128))
                              ])
                            ])
                          ]),
                          _hoisted_97,
                          _createVNode(_component_el_input, {
                            modelValue: item.remarks,
                            "onUpdate:modelValue": ($event: any) => ((item.remarks) = $event),
                            placeholder: "请输入备注",
                            style: {"width":"300px","margin-top":"10px"}
                          }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                          _createElementVNode("h4", null, _toDisplayString(item.updateremark), 1),
                          _createElementVNode("div", null, [
                            _hoisted_98,
                            _createVNode(_component_el_select, {
                              onChange: ($event: any) => (changemyd(item)),
                              filterable: "",
                              modelValue: item.pj,
                              "onUpdate:modelValue": ($event: any) => ((item.pj) = $event),
                              placeholder: "请选择",
                              style: {"width":"300px","margin-top":"10px"}
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pjLists.value, (item, index) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    label: item,
                                    value: `${item}`,
                                    key: `${item}`
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1032, ["onChange", "modelValue", "onUpdate:modelValue"])
                          ])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }),
            _hoisted_99
          ]))
        : _createCommentVNode("", true),
      (form.value.type1=='日事日毕')
        ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
            _hoisted_101,
            _hoisted_102,
            _createVNode(_component_el_descriptions, {
              column: 2,
              border: "",
              title: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_descriptions_item, null, {
                  label: _withCtx(() => [
                    _createElementVNode("div", _hoisted_103, [
                      _createVNode(_component_el_icon, { style: {"margin-right":"3px"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_PriceTag)
                        ]),
                        _: 1
                      }),
                      _hoisted_104
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" " + _toDisplayString(form.value.rkrq), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, null, {
                  label: _withCtx(() => [
                    _createElementVNode("div", _hoisted_105, [
                      _createVNode(_component_el_icon, { style: {"margin-right":"3px"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_PriceTag)
                        ]),
                        _: 1
                      }),
                      _hoisted_106
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" " + _toDisplayString(form.value.rkr), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, null, {
                  label: _withCtx(() => [
                    _createElementVNode("div", _hoisted_107, [
                      _createVNode(_component_el_icon, { style: {"margin-right":"3px"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_PriceTag)
                        ]),
                        _: 1
                      }),
                      _hoisted_108
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" " + _toDisplayString(form.value.rklb), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, null, {
                  label: _withCtx(() => [
                    _createElementVNode("div", _hoisted_109, [
                      _createVNode(_component_el_icon, { style: {"margin-right":"3px"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_PriceTag)
                        ]),
                        _: 1
                      }),
                      _hoisted_110
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" " + _toDisplayString(form.value.xdr), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, null, {
                  label: _withCtx(() => [
                    _createElementVNode("div", _hoisted_111, [
                      _createVNode(_component_el_icon, { style: {"margin-right":"3px"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_PriceTag)
                        ]),
                        _: 1
                      }),
                      _hoisted_112
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" " + _toDisplayString(form.value.cwlb), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, null, {
                  label: _withCtx(() => [
                    _createElementVNode("div", _hoisted_113, [
                      _createVNode(_component_el_icon, { style: {"margin-right":"3px"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_PriceTag)
                        ]),
                        _: 1
                      }),
                      _hoisted_114
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" " + _toDisplayString(form.value.mkgsyg), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, null, {
                  label: _withCtx(() => [
                    _createElementVNode("div", _hoisted_115, [
                      _createVNode(_component_el_icon, { style: {"margin-right":"3px"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_PriceTag)
                        ]),
                        _: 1
                      }),
                      _hoisted_116
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" " + _toDisplayString(form.value.zrfqz) + " " + _toDisplayString(form.value.zrfqzsj) + " ", 1),
                    _createElementVNode("a", {
                      href: "javascript:void(0);",
                      onClick: _cache[22] || (_cache[22] = ($event: any) => (qz(form.value.id))),
                      style: {"color":"#409EFF"}
                    }, "签字")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _hoisted_117,
            _createVNode(_component_el_input, {
              autosize: {minRows: 6},
              type: "textarea",
              modelValue: form.value.gjcs,
              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((form.value.gjcs) = $event)),
              placeholder: "请输入改进措施"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: _cache[24] || (_cache[24] = ($event: any) => (savegjcs(form.value.id))),
              style: {"margin-top":"10px","margin-bottom":"10px"}
            }, {
              default: _withCtx(() => [
                _hoisted_118
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _hoisted_119,
      _hoisted_120,
      _hoisted_121,
      _createElementVNode("div", _hoisted_122, [
        _createVNode(_component_el_button, {
          type: "primary",
          size: "small",
          onClick: addReminder,
          style: {"margin-bottom":"10px"}
        }, {
          default: _withCtx(() => [
            _hoisted_123
          ]),
          _: 1
        }),
        (reminderList.value.length===0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_124, "暂无提醒配置"))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reminderList.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "reminder-item"
          }, [
            _createElementVNode("div", _hoisted_125, [
              _hoisted_126,
              _createVNode(_component_el_select, {
                modelValue: item.remindtype,
                "onUpdate:modelValue": ($event: any) => ((item.remindtype) = $event),
                size: "small",
                style: {"width":"180px"},
                disabled: item.status==='1'
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: "定时提醒",
                    value: "scheduled"
                  }),
                  _createVNode(_component_el_option, {
                    label: "立即提醒",
                    value: "immediate"
                  }),
                  _createVNode(_component_el_option, {
                    label: "立即钉钉工作通知推送",
                    value: "ddwork"
                  }),
                  _createVNode(_component_el_option, {
                    label: "定时钉钉工作通知推送",
                    value: "ddwork_scheduled"
                  })
                ]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue", "disabled"]),
              _hoisted_127,
              _createVNode(_component_el_select, {
                modelValue: item.remindusers,
                "onUpdate:modelValue": ($event: any) => ((item.remindusers) = $event),
                multiple: "",
                filterable: "",
                "collapse-tags": "",
                "collapse-tags-tooltip": "",
                placeholder: "请选择（可多选）",
                size: "small",
                style: {"width":"230px"}
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userLists.value, (u, ui) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      label: u.name,
                      value: u.name,
                      key: ui
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue"]),
              (item.remindtype==='scheduled' || item.remindtype==='ddwork_scheduled')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_128,
                    _createVNode(_component_el_date_picker, {
                      modelValue: item.remindtime,
                      "onUpdate:modelValue": ($event: any) => ((item.remindtime) = $event),
                      type: "datetime",
                      placeholder: "选择提醒时间",
                      "value-format": "YYYY-MM-DD HH:mm:ss",
                      size: "small",
                      style: {"width":"190px"}
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ], 64))
                : _createCommentVNode("", true),
              (item.status==='1')
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 1,
                    type: item.readstatus==='1'?'success':'warning',
                    size: "small",
                    style: {"margin-left":"8px"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.readstatus==='1'?'已读':'未读'), 1)
                    ]),
                    _: 2
                  }, 1032, ["type"]))
                : _createCommentVNode("", true),
              (item.status==='1' && item.readstatus!=='1')
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 2,
                    type: "primary",
                    size: "small",
                    onClick: ($event: any) => (markReminderRead(item)),
                    style: {"margin-left":"4px"}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_129
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              _createVNode(_component_el_button, {
                type: "primary",
                size: "small",
                onClick: ($event: any) => (saveReminder(item)),
                style: {"margin-left":"8px"},
                disabled: item.status==='1'
              }, {
                default: _withCtx(() => [
                  _hoisted_130
                ]),
                _: 2
              }, 1032, ["onClick", "disabled"]),
              _createVNode(_component_el_button, {
                type: "danger",
                size: "small",
                onClick: ($event: any) => (deleteReminder(item,index)),
                style: {"margin-left":"4px"}
              }, {
                default: _withCtx(() => [
                  _hoisted_131
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            (isDDWorkType(item.remindtype))
              ? (_openBlock(), _createElementBlock("div", _hoisted_132, [
                  _hoisted_133,
                  _createVNode(_component_el_input, {
                    modelValue: item.content,
                    "onUpdate:modelValue": ($event: any) => ((item.content) = $event),
                    type: "textarea",
                    rows: 2,
                    size: "small",
                    style: {"width":"520px"},
                    placeholder: "可自定义提醒内容；未填写时默认发送任务标题"
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_134, _hoisted_136))
          ]))
        }), 128))
      ]),
      _hoisted_137,
      _hoisted_138,
      _hoisted_139,
      _createVNode(_component_el_input, {
        readonly: "",
        autosize: {minRows: 6},
        type: "textarea",
        modelValue: form.value.taskdescribe,
        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((form.value.taskdescribe) = $event)),
        placeholder: "请输入任务描述"
      }, null, 8, ["modelValue"]),
      (taskTypeConfig.value.requirements || _unref(parsedTemplateFiles).length > 0 || requiredUploadNames.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_140, [
            _hoisted_141,
            _createElementVNode("div", _hoisted_142, "⚠ 事项类型要求（" + _toDisplayString(form.value.type1) + "）", 1),
            (taskTypeConfig.value.requirements)
              ? (_openBlock(), _createElementBlock("div", _hoisted_143, [
                  _hoisted_144,
                  _createElementVNode("div", _hoisted_145, _toDisplayString(taskTypeConfig.value.requirements), 1)
                ]))
              : _createCommentVNode("", true),
            (_unref(parsedTemplateFiles).length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_146, [
                  _hoisted_147,
                  _createElementVNode("div", _hoisted_148, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(parsedTemplateFiles), (tf, ti) => {
                      return (_openBlock(), _createElementBlock("a", {
                        key: ti,
                        href: `${apiname.value}${tf.url}`,
                        target: "_blank",
                        class: "template-file-link"
                      }, [
                        _createVNode(_component_el_icon, {
                          size: 20,
                          color: "#409EFF"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Document)
                          ]),
                          _: 1
                        }),
                        _createElementVNode("span", null, _toDisplayString(tf.name), 1)
                      ], 8, _hoisted_149))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (requiredUploadNames.value.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_150, [
                  _createElementVNode("div", _hoisted_151, [
                    _hoisted_152,
                    _createElementVNode("span", {
                      style: _normalizeStyle({color: checkAllRequiredUploaded() ? '#67C23A' : '#F56C6C'})
                    }, _toDisplayString(getUploadedCount()) + "/" + _toDisplayString(requiredUploadNames.value.length), 5),
                    _hoisted_153
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(requiredUploadNames.value, (name, ri) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: ri,
                      class: "req-upload-item"
                    }, [
                      _createElementVNode("div", _hoisted_154, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["req-upload-name", {'uploaded': requiredUploadsMap.value[name]}])
                        }, _toDisplayString(requiredUploadsMap.value[name] ? '✅' : '⬜') + " " + _toDisplayString(name), 3),
                        (!requiredUploadsMap.value[name])
                          ? (_openBlock(), _createBlock(_component_el_button, {
                              key: 0,
                              type: "primary",
                              size: "small",
                              onClick: ($event: any) => (triggerRequiredUpload(name))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_155
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createElementVNode("a", {
                                href: `${apiname.value}${requiredUploadsMap.value[name]}`,
                                target: "_blank",
                                style: {"color":"#409EFF","margin-right":"8px","font-size":"12px"}
                              }, "查看", 8, _hoisted_156),
                              _createVNode(_component_el_button, {
                                type: "danger",
                                size: "small",
                                onClick: ($event: any) => (removeRequiredFile(name))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_157
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ], 64))
                      ]),
                      _createElementVNode("input", {
                        type: "file",
                        ref_for: true,
                        ref: el => setUploadRef(name, el),
                        style: {"display":"none"},
                        onChange: (e) => handleRequiredFileChange(e, name)
                      }, null, 40, _hoisted_158)
                    ]))
                  }), 128)),
                  _createVNode(_component_el_button, {
                    type: "primary",
                    size: "small",
                    onClick: saveRequiredFilesToServer,
                    disabled: getUploadedCount() === 0,
                    style: {"margin-top":"8px"}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_159
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _hoisted_160,
      _hoisted_161,
      _hoisted_162,
      _createVNode(_component_el_input_number, {
        modelValue: finishPercent.value,
        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((finishPercent).value = $event)),
        min: 0,
        max: 100,
        step: 5,
        "controls-position": "right",
        style: {"width":"160px"}
      }, null, 8, ["modelValue"]),
      _hoisted_163,
      _createVNode(_component_el_progress, {
        percentage: finishPercent.value,
        "stroke-width": 12,
        style: {"width":"240px","display":"inline-block","vertical-align":"middle","margin-left":"16px"}
      }, null, 8, ["percentage"]),
      _createVNode(_component_el_button, {
        type: "primary",
        style: {"margin-left":"16px"},
        onClick: saveFinishPercent
      }, {
        default: _withCtx(() => [
          _hoisted_164
        ]),
        _: 1
      }),
      (form.value.type1=='售前-常规材料' || form.value.type1=='订单信息-材料到位时间')
        ? (_openBlock(), _createElementBlock("div", _hoisted_165, [
            _hoisted_166,
            _hoisted_167,
            _hoisted_168,
            _createElementVNode("div", _hoisted_169, "正常流程：" + _toDisplayString(liuceng1.value), 1),
            _createElementVNode("div", _hoisted_170, "加工流程：" + _toDisplayString(liuceng2.value), 1),
            _createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: _cache[27] || (_cache[27] = ($event: any) => (addsubline('投产前备料'))),
              style: {"margin-top":"10px","margin-bottom":"10px"}
            }, {
              default: _withCtx(() => [
                _hoisted_171
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: _cache[28] || (_cache[28] = ($event: any) => (savesubline())),
              style: {"margin-top":"10px","margin-bottom":"10px"}
            }, {
              default: _withCtx(() => [
                _hoisted_172
              ]),
              _: 1
            }),
            _hoisted_173,
            _createVNode(_component_el_timeline, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subTaskList.value, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_timeline_item, {
                    center: "",
                    placement: "top",
                    key: index
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_card, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            onClick: ($event: any) => (deletesubline(item,index)),
                            round: "",
                            style: {"background-color":"#f56c6c","color":"#fff","float":"right"}
                          }, {
                            default: _withCtx(() => [
                              _hoisted_174
                            ]),
                            _: 2
                          }, 1032, ["onClick"]),
                          _withDirectives(_createElementVNode("input", {
                            type: "hidden",
                            "onUpdate:modelValue": ($event: any) => ((item.id) = $event)
                          }, null, 8, _hoisted_175), [
                            [_vModelText, item.id]
                          ]),
                          _withDirectives(_createElementVNode("input", {
                            type: "hidden",
                            "onUpdate:modelValue": ($event: any) => ((item.taskid) = $event)
                          }, null, 8, _hoisted_176), [
                            [_vModelText, item.taskid]
                          ]),
                          _createVNode(_component_el_input, {
                            modelValue: item.remarks,
                            "onUpdate:modelValue": ($event: any) => ((item.remarks) = $event),
                            placeholder: "请输入备货信息",
                            style: {"width":"400px","margin-top":"10px"}
                          }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                          _createElementVNode("div", _hoisted_177, [
                            _createTextVNode(" 确认备货人： " + _toDisplayString(item.username) + " - " + _toDisplayString(item.checktime) + " （" + _toDisplayString(subtaskinfostatus( item.status )) + "） ", 1),
                            (item.id!=0&&(item.status==2||item.status==0))
                              ? (_openBlock(), _createBlock(_component_el_button, {
                                  key: 0,
                                  onClick: ($event: any) => (CheckSubTaskInfo(item,index,1)),
                                  round: "",
                                  style: {"background-color":"#409eff","color":"#fff"}
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_178
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              : _createCommentVNode("", true),
                            (item.id!=0&&(item.status==1||item.status==0))
                              ? (_openBlock(), _createBlock(_component_el_button, {
                                  key: 1,
                                  onClick: ($event: any) => (CheckSubTaskInfo(item,index,2)),
                                  round: "",
                                  style: {"background-color":"#f56c6c","color":"#fff"}
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_179
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _hoisted_180,
      _hoisted_181,
      _hoisted_182,
      (fileList.value.length>0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_183, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fileList.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                style: {"margin-right":"14px","display":"inline-flex","flex-direction":"column","align-items":"center"}
              }, [
                _createVNode(_component_el_badge, {
                  value: getVoidFile(fileUrlOf(item)) ? '作废' : '',
                  hidden: !getVoidFile(fileUrlOf(item)),
                  type: "danger"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("a", {
                      href: fileOpenUrl(item),
                      target: "_blank",
                      style: _normalizeStyle([{"display":"inline-flex","flex-direction":"column","align-items":"center","text-decoration":"none"}, getVoidFile(fileUrlOf(item)) ? 'opacity:.5;' : ''])
                    }, [
                      _createVNode(_component_el_icon, {
                        size: 36,
                        color: "#409EFF"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Document)
                        ]),
                        _: 1
                      })
                    ], 12, _hoisted_184)
                  ]),
                  _: 2
                }, 1032, ["value", "hidden"]),
                _createElementVNode("span", {
                  style: _normalizeStyle([{"font-size":"12px","color":"#606266","max-width":"90px","overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap"}, getVoidFile(fileUrlOf(item)) ? 'text-decoration:line-through;color:#c0c4cc;' : ''])
                }, _toDisplayString(parseFileItem(item).name), 5),
                (getVoidFile(fileUrlOf(item)))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_185, " 原因：" + _toDisplayString(getVoidFile(fileUrlOf(item)).voidreason), 1))
                  : _createCommentVNode("", true),
                (!getVoidFile(fileUrlOf(item)))
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      link: "",
                      type: "danger",
                      size: "small",
                      style: {"margin-top":"2px"},
                      onClick: ($event: any) => (voidTaskFile(item))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_186
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_187, "无")),
      _hoisted_188,
      _hoisted_189,
      _hoisted_190,
      (!formInstance.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_191, [
            _createElementVNode("div", _hoisted_192, [
              _hoisted_193,
              _createVNode(_component_el_select, {
                filterable: "",
                modelValue: selectedTemplateId.value,
                "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((selectedTemplateId).value = $event)),
                placeholder: "请选择表单模板",
                style: {"width":"250px"},
                size: "small"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: "请选择",
                    value: 0
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formTemplateList.value, (item, index) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      label: item.formname,
                      value: Number(item.id),
                      key: index
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_button, {
                type: "primary",
                size: "small",
                onClick: _cache[30] || (_cache[30] = ($event: any) => (createFormInstance())),
                style: {"margin-left":"10px"}
              }, {
                default: _withCtx(() => [
                  _hoisted_194
                ]),
                _: 1
              })
            ]),
            (formTemplateList.value.length===0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_195, "暂无表单模板，请先在【表单管理】-【表单模板配置】中添加"))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_196, [
            _createElementVNode("div", _hoisted_197, [
              _createElementVNode("div", _hoisted_198, [
                _hoisted_199,
                _createElementVNode("span", null, _toDisplayString(formInstance.value.formname), 1)
              ]),
              _createElementVNode("div", _hoisted_200, [
                _hoisted_201,
                _createElementVNode("span", null, _toDisplayString(formInstance.value.principal), 1)
              ]),
              _createElementVNode("div", _hoisted_202, [
                _hoisted_203,
                _createElementVNode("span", {
                  style: _normalizeStyle({color: formInstance.value.status==='2'?'#67C23A':(formInstance.value.status==='0'?'#909399':'#E6A23C')})
                }, _toDisplayString(formInstance.value.status==='2'?'已完成':(formInstance.value.status==='0'?'未启动':'进行中')), 5)
              ]),
              _createVNode(_component_el_button, {
                type: "danger",
                size: "small",
                onClick: _cache[31] || (_cache[31] = ($event: any) => (deleteFormInstance())),
                style: {"margin-top":"5px"}
              }, {
                default: _withCtx(() => [
                  _hoisted_204
                ]),
                _: 1
              })
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formInstanceSteps.value, (step, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                key: step.id,
                class: _normalizeClass(["step-card-item", { 'is-focus-step': String(__props.focusStepId)!=='' && String(step.id)===String(__props.focusStepId) }]),
                id: 'form-step-'+step.id
              }, [
                _createElementVNode("div", _hoisted_206, [
                  _createElementVNode("span", null, "环节 " + _toDisplayString(idx+1) + "：" + _toDisplayString(step.stepdesc), 1),
                  (formInstance.value.createid == userList.value.id)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        type: "danger",
                        size: "small",
                        round: "",
                        onClick: ($event: any) => (deleteStep(step))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_207
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                (rejectInfoForStep(step))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_208, [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_WarningFilled)
                        ]),
                        _: 1
                      }),
                      _createElementVNode("span", null, "该环节曾被驳回：" + _toDisplayString(rejectInfoForStep(step).rejectby) + " 于 " + _toDisplayString(rejectInfoForStep(step).rejecttime) + " 驳回，原因：" + _toDisplayString(rejectInfoForStep(step).rejectreason), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_209, [
                  _createElementVNode("div", _hoisted_210, [
                    _hoisted_211,
                    _createElementVNode("span", null, _toDisplayString(step.executor || '未指定'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_212, [
                    _hoisted_213,
                    _createElementVNode("span", null, _toDisplayString(step.reviewer || '未指定'), 1)
                  ]),
                  (step.needattach==='1' || step.stepattach)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_214, [
                        _createElementVNode("div", _hoisted_215, [
                          _createElementVNode("label", null, [
                            _hoisted_216,
                            (step.needattach==='1')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_217, "必传"))
                              : _createCommentVNode("", true),
                            _hoisted_218
                          ])
                        ]),
                        _createVNode(_component_el_upload, {
                          ref_for: true,
                          ref: "stepUpload",
                          action: `${apiname.value}/frame/uploadfile1`,
                          "file-list": stepAttachUploadList.value[idx] || [],
                          "on-success": (res,file,fileList)=>onStepAttachSuccess(step,idx,res,file,fileList),
                          "on-remove": (file,fileList)=>onStepAttachRemove(step,idx,file,fileList),
                          onClick: ($event: any) => (setPasteTarget('step', idx)),
                          class: _normalizeClass({'paste_target':isPasteTarget('step',idx)}),
                          multiple: "",
                          "auto-upload": ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_button, {
                              type: "primary",
                              size: "small"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_219
                              ]),
                              _: 1
                            })
                          ]),
                          _: 2
                        }, 1032, ["action", "file-list", "on-success", "on-remove", "onClick", "class"]),
                        (step.stepattach)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_220, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(step.stepattach.split(','), (f, fi) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: fi,
                                  style: {"display":"inline-flex","flex-direction":"column","margin-right":"14px"}
                                }, [
                                  _createElementVNode("a", {
                                    href: `${apiname.value}${f}`,
                                    target: "_blank",
                                    style: _normalizeStyle([{"color":"#409EFF","font-size":"12px"}, getVoidFile(fileUrlOf(f)) ? 'opacity:.5;text-decoration:line-through;' : ''])
                                  }, [
                                    _createVNode(_component_el_icon, {
                                      size: 20,
                                      color: "#409EFF"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Document)
                                      ]),
                                      _: 1
                                    }),
                                    _createTextVNode(" 附件" + _toDisplayString(Number(fi)+1), 1)
                                  ], 12, _hoisted_221),
                                  (getVoidFile(fileUrlOf(f)))
                                    ? (_openBlock(), _createBlock(_component_el_tag, {
                                        key: 0,
                                        type: "danger",
                                        size: "small",
                                        style: {"margin-top":"2px"}
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_222
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  (getVoidFile(fileUrlOf(f)))
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_223, " 原因：" + _toDisplayString(getVoidFile(fileUrlOf(f)).voidreason), 1))
                                    : _createCommentVNode("", true),
                                  (!getVoidFile(fileUrlOf(f)))
                                    ? (_openBlock(), _createBlock(_component_el_button, {
                                        key: 2,
                                        link: "",
                                        type: "danger",
                                        size: "small",
                                        onClick: ($event: any) => (voidStepFile(step,f))
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_224
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_el_button, {
                          type: "primary",
                          size: "small",
                          onClick: ($event: any) => (saveStepData(step)),
                          style: {"margin-top":"5px"}
                        }, {
                          default: _withCtx(() => [
                            _hoisted_225
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]))
                    : _createCommentVNode("", true),
                  (step.needtime==='1')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_226, [
                        _createElementVNode("div", _hoisted_227, [
                          _hoisted_228,
                          _createVNode(_component_el_date_picker, {
                            modelValue: step.steptime,
                            "onUpdate:modelValue": ($event: any) => ((step.steptime) = $event),
                            type: "datetime",
                            placeholder: "选择完成时间",
                            "value-format": "YYYY-MM-DD HH:mm:ss",
                            size: "small",
                            style: {"width":"200px"}
                          }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                          _createVNode(_component_el_button, {
                            type: "primary",
                            size: "small",
                            onClick: ($event: any) => (saveStepData(step)),
                            style: {"margin-left":"8px"}
                          }, {
                            default: _withCtx(() => [
                              _hoisted_229
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (step.executorconclusion==='1')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_230, [
                        _hoisted_231,
                        _createVNode(_component_el_input, {
                          modelValue: step.stepconclusion,
                          "onUpdate:modelValue": ($event: any) => ((step.stepconclusion) = $event),
                          type: "textarea",
                          autosize: {minRows:2},
                          placeholder: "请输入结论",
                          size: "small"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                        _createVNode(_component_el_button, {
                          type: "primary",
                          size: "small",
                          onClick: ($event: any) => (saveStepData(step)),
                          style: {"margin-top":"5px"}
                        }, {
                          default: _withCtx(() => [
                            _hoisted_232
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_233, [
                    _hoisted_234,
                    (step.executorsign==='0')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_235, "无需签字"))
                      : (step.executorsignname)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_236, _toDisplayString(step.executorsignname) + " " + _toDisplayString(step.executorsigntime), 1))
                        : (_openBlock(), _createBlock(_component_el_button, {
                            key: 2,
                            type: "primary",
                            size: "small",
                            onClick: ($event: any) => (executorSign(step))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_237
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                  ]),
                  _createElementVNode("div", _hoisted_238, [
                    _hoisted_239,
                    (step.reviewersign==='0')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_240, "无需签字"))
                      : (step.reviewersignname)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_241, _toDisplayString(step.reviewersignname) + " " + _toDisplayString(step.reviewersigntime), 1))
                        : (_openBlock(), _createBlock(_component_el_button, {
                            key: 2,
                            type: "warning",
                            size: "small",
                            onClick: ($event: any) => (reviewerSign(step))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_242
                            ]),
                            _: 2
                          }, 1032, ["onClick"])),
                    (canRejectExecutor(step))
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 3,
                          type: "danger",
                          size: "small",
                          plain: "",
                          onClick: ($event: any) => (openRejectExecutor(step)),
                          style: {"margin-left":"8px"}
                        }, {
                          default: _withCtx(() => [
                            _hoisted_243
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  (canRejectStep(step))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_244, [
                        _createVNode(_component_el_button, {
                          type: "danger",
                          size: "small",
                          plain: "",
                          onClick: ($event: any) => (openReject(step))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_245
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ], 10, _hoisted_205))
            }), 128))
          ])),
      _createVNode(_component_el_dialog, {
        modelValue: rejectDialogVisible.value,
        "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((rejectDialogVisible).value = $event)),
        title: rejectType.value==='current' ? '驳回执行人提交' : '驳回上一道签字',
        width: "480px",
        "append-to-body": ""
      }, {
        footer: _withCtx(() => [
          _createVNode(_component_el_button, {
            onClick: _cache[33] || (_cache[33] = ($event: any) => (rejectDialogVisible.value=false))
          }, {
            default: _withCtx(() => [
              _hoisted_247
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "danger",
            onClick: confirmReject
          }, {
            default: _withCtx(() => [
              _hoisted_248
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_246, [
            (rejectType.value==='current')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(" 驳回后，本环节（" + _toDisplayString(rejectTargetStep.value ? rejectTargetStep.value.stepdesc : '') + "）执行人的签字将被清空，退回给执行人重新提交。请填写驳回原因。 ", 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(" 驳回后，上一道环节（" + _toDisplayString(rejectTargetStep.value ? rejectTargetStep.value.stepdesc : '') + "）的签字将被清空，流程退回该环节重新签字。请填写驳回原因。 ", 1)
                ], 64))
          ]),
          _createVNode(_component_el_input, {
            modelValue: rejectReason.value,
            "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((rejectReason).value = $event)),
            type: "textarea",
            autosize: {minRows:3},
            placeholder: "请输入驳回原因（必填）",
            maxlength: "500",
            "show-word-limit": ""
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["modelValue", "title"]),
      _hoisted_249,
      (form.value.type2 === '定额任务' && type4DataList.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_250, [
            _hoisted_251,
            _hoisted_252,
            _hoisted_253,
            _createVNode(_component_el_table, {
              data: type4DataList.value,
              border: "",
              style: {"width":"100%"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  prop: "name",
                  label: "名称",
                  width: "200"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "qty",
                  label: "任务总量",
                  width: "100",
                  align: "center"
                }),
                _createVNode(_component_el_table_column, {
                  label: "完成量",
                  width: "150",
                  align: "center"
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_el_input_number, {
                      modelValue: scope.row.completedQty,
                      "onUpdate:modelValue": ($event: any) => ((scope.row.completedQty) = $event),
                      min: 0,
                      size: "small",
                      "controls-position": "right",
                      onChange: ($event: any) => (onCompletedQtyChange(scope.row))
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "产品编号",
                  width: "200",
                  align: "center"
                }, {
                  default: _withCtx((scope) => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getSerialNumberInputs(scope.row), (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        style: {"margin-bottom":"5px"}
                      }, [
                        _createVNode(_component_el_input, {
                          modelValue: item.serialNumber,
                          "onUpdate:modelValue": ($event: any) => ((item.serialNumber) = $event),
                          placeholder: "请输入产品编号",
                          size: "small"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]))
                    }), 128))
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "问题描述",
                  width: "300",
                  align: "center"
                }, {
                  default: _withCtx((scope) => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getProblemDescInputs(scope.row), (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        style: {"margin-bottom":"5px"}
                      }, [
                        _createVNode(_component_el_input, {
                          modelValue: item.problemDesc,
                          "onUpdate:modelValue": ($event: any) => ((item.problemDesc) = $event),
                          placeholder: "请输入问题描述",
                          size: "small"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]))
                    }), 128))
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "进度",
                  width: "150",
                  align: "center"
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_el_progress, {
                      percentage: scope.row.qty > 0 ? Math.round((scope.row.completedQty / scope.row.qty) * 100) : 0,
                      status: scope.row.completedQty >= scope.row.qty ? 'success' : ''
                    }, null, 8, ["percentage", "status"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"])
          ]))
        : _createCommentVNode("", true),
      _hoisted_254,
      _createElementVNode("div", _hoisted_255, [
        _createVNode(_component_el_input, {
          autosize: {minRows: 6},
          type: "textarea",
          modelValue: form.value.sjwc,
          "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((form.value.sjwc) = $event)),
          placeholder: "请输入实际完成"
        }, null, 8, ["modelValue"]),
        _hoisted_256,
        (userrole.value != '经销商')
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              size: "small",
              onClick: _cache[36] || (_cache[36] = ($event: any) => (savesjwc())),
              style: {"margin-top":"10px","margin-bottom":"10px"}
            }, {
              default: _withCtx(() => [
                _hoisted_257
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", null, [
        (userrole.value != '经销商')
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              size: "small",
              onClick: _cache[37] || (_cache[37] = ($event: any) => (showoverstock.value=true)),
              style: {"margin-top":"10px","margin-bottom":"10px"}
            }, {
              default: _withCtx(() => [
                _hoisted_258
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (form.value.type1=='售前-评审')
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              type: "primary",
              size: "small",
              onClick: _cache[38] || (_cache[38] = ($event: any) => (showsqps.value=true)),
              style: {"margin-top":"10px","margin-bottom":"10px"}
            }, {
              default: _withCtx(() => [
                _hoisted_259
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_260, [
        _hoisted_261,
        (form.value.taskpid!=0)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: "javascript:void(0)",
              style: {"color":"#128fff","margin-left":"10px"},
              onClick: _cache[39] || (_cache[39] = ($event: any) => (toTask(form.value.taskpid)))
            }, "上级任务"))
          : _createCommentVNode("", true)
      ]),
      (userrole.value != '经销商')
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 9,
            type: "primary",
            size: "small",
            onClick: _cache[40] || (_cache[40] = ($event: any) => (createTask())),
            style: {"margin-top":"10px","margin-bottom":"10px"}
          }, {
            default: _withCtx(() => [
              _hoisted_262
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sonTaskList.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          style: {"line-height":"30px","cursor":"pointer"},
          onClick: ($event: any) => (toTask(item.id))
        }, _toDisplayString(item.tasktitle) + "(" + _toDisplayString(_unref(getStatus)(item.status)) + ")", 9, _hoisted_263))
      }), 128)),
      _hoisted_264,
      _createElementVNode("div", _hoisted_265, [
        _hoisted_266,
        (isTaskStarter.value)
          ? (_openBlock(), _createBlock(_component_el_tag, {
              key: 0,
              type: "success",
              size: "small"
            }, {
              default: _withCtx(() => [
                _hoisted_267
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_el_tag, {
              key: 1,
              type: "info",
              size: "small"
            }, {
              default: _withCtx(() => [
                _hoisted_268
              ]),
              _: 1
            }))
      ]),
      _createElementVNode("div", _hoisted_269, [
        _hoisted_270,
        _createVNode(_component_el_switch, {
          modelValue: showInWorkbench.value,
          "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((showInWorkbench).value = $event)),
          loading: workbenchToggling.value,
          "active-text": "显示",
          "inactive-text": "不显示",
          onChange: toggleWorkbenchShow
        }, null, 8, ["modelValue", "loading"]),
        _hoisted_271
      ]),
      _hoisted_272,
      _hoisted_273,
      _hoisted_274,
      (Number(form.value.status) === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_275, [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_component_Warning)
              ]),
              _: 1
            }),
            _hoisted_276
          ]))
        : _createCommentVNode("", true),
      (form.value.type2=='计量任务')
        ? (_openBlock(), _createElementBlock("div", _hoisted_277, [
            _hoisted_278,
            _createVNode(_component_el_date_picker, {
              modelValue: jlbjrq.value,
              "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((jlbjrq).value = $event)),
              type: "datetime",
              placeholder: "选择计量补交时间",
              "value-format": "YYYY-MM-DD HH:mm:ss"
            }, null, 8, ["modelValue"])
          ]))
        : _createCommentVNode("", true),
      _hoisted_279,
      _createElementVNode("div", _hoisted_280, [
        _createVNode(_component_el_input, {
          autosize: {minRows: 6},
          type: "textarea",
          modelValue: updateremark.value,
          "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((updateremark).value = $event)),
          placeholder: "请输入任务日志",
          disabled: Number(form.value.status) === 0
        }, null, 8, ["modelValue", "disabled"]),
        _hoisted_281,
        _createVNode(_component_el_upload, {
          action: `${apiname.value}/frame/uploadfile1`,
          "file-list": addFileList.value,
          onClick: _cache[44] || (_cache[44] = ($event: any) => (setPasteTarget('log'))),
          class: _normalizeClass({'paste_target':isPasteTarget('log')}),
          disabled: Number(form.value.status) === 0
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              disabled: Number(form.value.status) === 0
            }, {
              default: _withCtx(() => [
                _hoisted_282
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        }, 8, ["action", "file-list", "class", "disabled"]),
        _createElementVNode("div", _hoisted_283, [
          (form.value.type1=='售前-常规材料')
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "warning",
                onClick: _cache[45] || (_cache[45] = ($event: any) => (submit(1,'任务流程-售前-常规材料'))),
                round: "",
                disabled: Number(form.value.status) === 0
              }, {
                default: _withCtx(() => [
                  _hoisted_284
                ]),
                _: 1
              }, 8, ["disabled"]))
            : _createCommentVNode("", true),
          (form.value.type2=='计量任务')
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                type: "primary",
                onClick: _cache[46] || (_cache[46] = ($event: any) => (submit(-1,''))),
                round: "",
                disabled: Number(form.value.status) === 0
              }, {
                default: _withCtx(() => [
                  _hoisted_285
                ]),
                _: 1
              }, 8, ["disabled"]))
            : _createCommentVNode("", true),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[47] || (_cache[47] = ($event: any) => (submit(1,''))),
            round: "",
            disabled: Number(form.value.status) === 0
          }, {
            default: _withCtx(() => [
              _hoisted_286
            ]),
            _: 1
          }, 8, ["disabled"]),
          (form.value.status==1)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 2,
                type: "warning",
                onClick: _cache[48] || (_cache[48] = ($event: any) => (submit(3,''))),
                round: "",
                disabled: !checkRequiredFilesForSubmit()
              }, {
                default: _withCtx(() => [
                  _hoisted_287
                ]),
                _: 1
              }, 8, ["disabled"]))
            : _createCommentVNode("", true),
          (form.value.status==3&&shr.value==getUserIdName())
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 3,
                type: "success",
                onClick: _cache[49] || (_cache[49] = ($event: any) => (submit(4,''))),
                round: "",
                disabled: !checkRequiredFilesForSubmit()
              }, {
                default: _withCtx(() => [
                  _hoisted_288
                ]),
                _: 1
              }, 8, ["disabled"]))
            : _createCommentVNode("", true),
          (form.value.status==3&&shr.value==getUserIdName())
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 4,
                type: "danger",
                onClick: _cache[50] || (_cache[50] = ($event: any) => (submit(1,'审核不通过'))),
                round: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_289
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (form.value.status==3)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 5,
                type: "danger",
                onClick: _cache[51] || (_cache[51] = ($event: any) => (submit(1,'撤回'))),
                round: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_290
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        (_unref(isOrderInfoType))
          ? (_openBlock(), _createElementBlock("div", _hoisted_291, [
              _createVNode(_component_el_checkbox, {
                modelValue: syncToOrder.value,
                "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((syncToOrder).value = $event))
              }, {
                default: _withCtx(() => [
                  _hoisted_292
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true),
        (form.value.status==4&&form.value.pj==0&&form.value.checkuserid==userList.value.id)
          ? (_openBlock(), _createElementBlock("div", _hoisted_293, [
              _hoisted_294,
              _createElementVNode("div", _hoisted_295, [
                _createVNode(_component_el_button, {
                  type: "success",
                  onClick: _cache[53] || (_cache[53] = ($event: any) => (submitpj(1))),
                  round: ""
                }, {
                  default: _withCtx(() => [
                    _hoisted_296
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[54] || (_cache[54] = ($event: any) => (submitpj(2))),
                  round: ""
                }, {
                  default: _withCtx(() => [
                    _hoisted_297
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  type: "danger",
                  onClick: _cache[55] || (_cache[55] = ($event: any) => (submitpj(3))),
                  round: ""
                }, {
                  default: _withCtx(() => [
                    _hoisted_298
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_299, [
      _hoisted_300,
      _hoisted_301,
      _createVNode(_component_el_timeline, null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(logList.value, (item, index) => {
            return (_openBlock(), _createBlock(_component_el_timeline_item, {
              center: "",
              timestamp: `${item.updatetime} ${item.updatename} ${_unref(getStatus)(item.updatestatus)}`,
              placement: "top",
              key: index,
              id: 'tasklog-'+item.id,
              class: _normalizeClass({'is-focus-log': String(__props.focusLogId)!=='' && String(item.id)===String(__props.focusLogId) })
            }, {
              default: _withCtx(() => [
                (Number(item.voidflag) === 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_302, [
                      _createVNode(_component_el_tag, {
                        type: "danger",
                        size: "small"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_303
                        ]),
                        _: 1
                      }),
                      _createElementVNode("span", _hoisted_304, "作废原因：" + _toDisplayString(item.voidreason || '-'), 1),
                      _createElementVNode("span", _hoisted_305, "（" + _toDisplayString(item.voidname || '-') + " " + _toDisplayString(item.voidtime || '') + "）", 1)
                    ]))
                  : _createCommentVNode("", true),
                (item.filelist=='')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_306, [
                      _createElementVNode("span", {
                        style: _normalizeStyle(Number(item.voidflag) === 1 ? 'color:#c0c4cc;text-decoration:line-through;' : '')
                      }, _toDisplayString(item.updateremark), 5)
                    ]))
                  : (_openBlock(), _createBlock(_component_el_card, { key: 2 }, {
                      default: _withCtx(() => [
                        _createElementVNode("h4", {
                          style: _normalizeStyle(Number(item.voidflag) === 1 ? 'color:#c0c4cc;text-decoration:line-through;' : '')
                        }, _toDisplayString(item.updateremark), 5),
                        _createElementVNode("p", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.filelist.split(','), (v, i) => {
                            return (_openBlock(), _createElementBlock("a", {
                              href: fileOpenUrl(v),
                              target: "_blank",
                              key: i,
                              style: {"margin-right":"14px","display":"inline-flex","flex-direction":"column","align-items":"center","text-decoration":"none"}
                            }, [
                              _createVNode(_component_el_icon, {
                                size: 36,
                                color: "#409EFF"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Document)
                                ]),
                                _: 1
                              }),
                              _createElementVNode("span", _hoisted_308, _toDisplayString(parseFileItem(v).name), 1)
                            ], 8, _hoisted_307))
                          }), 128))
                        ])
                      ]),
                      _: 2
                    }, 1024)),
                _createElementVNode("div", _hoisted_309, [
                  (Number(item.voidflag) !== 1 && item.id)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        link: "",
                        type: "danger",
                        size: "small",
                        onClick: ($event: any) => (voidLog(item))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_310
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 2
            }, 1032, ["timestamp", "id", "class"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_el_dialog, {
      top: "5vh",
      modelValue: addShowTask.value,
      "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((addShowTask).value = $event)),
      "show-close": false,
      "close-on-click-modal": false
    }, {
      header: _withCtx(({ close, titleId, titleClass }) => [
        _createElementVNode("div", _hoisted_311, [
          _hoisted_312,
          _createVNode(_component_el_icon, {
            class: "delicon",
            onClick: _cache[56] || (_cache[56] = ($event: any) => (addShowTask.value=false)),
            style: {"float":"right"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Close)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        (addTask.value)
          ? (_openBlock(), _createBlock(AddTask, {
              key: 0,
              id: form.value.projectid,
              taskid: form.value.id,
              onCancelTask: cancelTask
            }, null, 8, ["id", "taskid"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: projectInfoShow.value,
      "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((projectInfoShow).value = $event)),
      "show-close": false,
      "close-on-click-modal": false,
      width: "88%",
      top: "4vh"
    }, {
      header: _withCtx(({ close, titleId, titleClass }) => [
        _createElementVNode("div", _hoisted_313, [
          _createElementVNode("div", null, "完善项目信息 - " + _toDisplayString(projectobj.value.projectname), 1),
          _createVNode(_component_el_icon, {
            class: "delicon",
            onClick: _cache[58] || (_cache[58] = ($event: any) => (projectInfoShow.value=false))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Close)
            ]),
            _: 1
          })
        ])
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[59] || (_cache[59] = ($event: any) => (projectInfoShow.value=false))
        }, {
          default: _withCtx(() => [
            _hoisted_314
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: saveProjectInfo,
          loading: projectInfoSaving.value
        }, {
          default: _withCtx(() => [
            _hoisted_315
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        (projectInfoShow.value)
          ? (_openBlock(), _createBlock(ProjectInfoEdit, {
              key: 0,
              ref_key: "projectInfoRef",
              ref: projectInfoRef,
              projectuuid: projectobj.value.uuid,
              projectname: projectobj.value.projectname,
              projectcode: projectobj.value.code,
              onSaved: onProjectInfoSaved
            }, null, 8, ["projectuuid", "projectname", "projectcode"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(ProjectAllFiles, {
      ref_key: "allFilesRef",
      ref: allFilesRef
    }, null, 512),
    _createVNode(_component_el_dialog, {
      top: "5vh",
      modelValue: showoverstock.value,
      "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((showoverstock).value = $event)),
      "show-close": false,
      "close-on-click-modal": false,
      width: "90%"
    }, {
      header: _withCtx(({ close, titleId, titleClass }) => [
        _createElementVNode("div", _hoisted_316, [
          _hoisted_317,
          _createVNode(_component_el_icon, {
            class: "delicon",
            onClick: _cache[61] || (_cache[61] = ($event: any) => (showoverstock.value=false)),
            style: {"float":"right"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Close)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        (showoverstock.value)
          ? (_openBlock(), _createBlock(OverstockList, {
              key: 0,
              onCancelTask: _cache[62] || (_cache[62] = ($event: any) => (showoverstock.value=false))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      top: "5vh",
      modelValue: showsqps.value,
      "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => ((showsqps).value = $event)),
      "show-close": false,
      "close-on-click-modal": false
    }, {
      header: _withCtx(({ close, titleId, titleClass }) => [
        _createElementVNode("div", _hoisted_318, [
          _hoisted_319,
          _createVNode(_component_el_icon, {
            class: "delicon",
            onClick: _cache[64] || (_cache[64] = ($event: any) => (showsqps.value=false)),
            style: {"float":"right"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Close)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        (showsqps.value)
          ? (_openBlock(), _createBlock(sqpspage, {
              key: 0,
              sqpsidid: form.value.sqpsid,
              taskid: form.value.id,
              onCancelTask: _cache[65] || (_cache[65] = ($event: any) => (showsqps.value=false))
            }, null, 8, ["sqpsidid", "taskid"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: changeReasonDialog.value,
      "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event: any) => ((changeReasonDialog).value = $event)),
      title: "请输入修改原因",
      width: "400px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_input, {
          modelValue: updateremark.value,
          "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event: any) => ((updateremark).value = $event)),
          type: "textarea",
          autosize: {minRows: 3},
          placeholder: "请输入修改原因"
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_320, [
          _createVNode(_component_el_button, {
            onClick: _cache[68] || (_cache[68] = ($event: any) => (changeReasonDialog.value = false))
          }, {
            default: _withCtx(() => [
              _hoisted_321
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: confirmChangeTime
          }, {
            default: _withCtx(() => [
              _hoisted_322
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: ontimeReasonDialog.value,
      "onUpdate:modelValue": _cache[72] || (_cache[72] = ($event: any) => ((ontimeReasonDialog).value = $event)),
      title: "请填写反馈原因",
      width: "450px",
      "close-on-click-modal": false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_input, {
          modelValue: ontimeReason.value,
          "onUpdate:modelValue": _cache[70] || (_cache[70] = ($event: any) => ((ontimeReason).value = $event)),
          type: "textarea",
          autosize: {minRows: 3},
          placeholder: "请填写不能按时按要求完成的原因"
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_323, [
          _createVNode(_component_el_button, {
            onClick: _cache[71] || (_cache[71] = ($event: any) => (ontimeReasonDialog.value = false))
          }, {
            default: _withCtx(() => [
              _hoisted_324
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: confirmOnTimeReason
          }, {
            default: _withCtx(() => [
              _hoisted_325
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_326, [
      _hoisted_327,
      _createElementVNode("b", null, _toDisplayString(_unref(pasteTargetName)), 1),
      (pasteUploading.value)
        ? (_openBlock(), _createElementBlock("span", _hoisted_328, "上传中…"))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})